import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.json.parse.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Transition as _Transition, Teleport as _Teleport, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "workflow-designer flex flex-col bg-slate-50 overflow-hidden",
  style: {
    "margin": "-1.5rem",
    "height": "calc(100% + 3rem)"
  }
};
const _hoisted_2 = {
  class: "h-14 bg-white border-b border-slate-200 flex items-center justify-between px-4 shadow-sm shrink-0"
};
const _hoisted_3 = {
  class: "flex items-center gap-3"
};
const _hoisted_4 = {
  class: "text-base font-semibold text-slate-800"
};
const _hoisted_5 = {
  class: "bg-white border-b border-slate-200 shrink-0"
};
const _hoisted_6 = {
  class: "flex-1 overflow-hidden"
};
const _hoisted_7 = {
  class: "h-full overflow-auto p-6"
};
const _hoisted_8 = {
  class: "max-w-2xl mx-auto"
};
const _hoisted_9 = {
  class: "bg-white rounded-xl shadow-sm border border-slate-200 p-6"
};
const _hoisted_10 = {
  class: "flex items-center gap-3 mb-4"
};
const _hoisted_11 = {
  class: "w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center"
};
const _hoisted_12 = {
  class: "flex items-center gap-3"
};
const _hoisted_13 = {
  class: "w-12 h-12 rounded-lg border-2 border-dashed border-slate-300 flex items-center justify-center cursor-pointer hover:border-primary-400 hover:bg-primary-50 transition-colors"
};
const _hoisted_14 = {
  class: "mt-4 flex justify-end gap-2"
};
const _hoisted_15 = {
  class: "h-full flex flex-col"
};
const _hoisted_16 = {
  class: "flex-1 overflow-auto min-h-0"
};
const _hoisted_17 = {
  class: "bg-white border-t border-slate-200 px-6 pb-4"
};
const _hoisted_18 = {
  class: "export-tab-header"
};
const _hoisted_19 = {
  class: "flex items-center gap-2"
};
const _hoisted_20 = {
  class: "h-[600px] flex flex-col border border-slate-200 rounded-lg overflow-hidden"
};
const _hoisted_21 = {
  class: "export-tab-empty"
};
const _hoisted_22 = {
  class: "empty-content"
};
const _hoisted_23 = {
  class: "export-tab-header"
};
const _hoisted_24 = {
  class: "flex items-center gap-2"
};
const _hoisted_25 = {
  class: "export-tab-empty"
};
const _hoisted_26 = {
  class: "empty-content"
};
const _hoisted_27 = {
  class: "bg-white border-t border-slate-200 px-6 py-3 flex justify-between items-center shrink-0"
};
const _hoisted_28 = {
  class: "flex items-center gap-3"
};
const _hoisted_29 = {
  class: "text-sm text-slate-500"
};
const _hoisted_30 = {
  class: "text-slate-700"
};
const _hoisted_31 = {
  class: "h-full flex flex-col"
};
const _hoisted_32 = {
  class: "h-12 bg-white border-b border-slate-200 flex items-center justify-between px-4 shrink-0"
};
const _hoisted_33 = {
  class: "flex items-center gap-3"
};
const _hoisted_34 = {
  class: "flex items-center bg-slate-100 rounded-lg p-0.5"
};
const _hoisted_35 = {
  class: "px-2 text-xs font-medium text-slate-600 min-w-[48px] text-center"
};
const _hoisted_36 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_37 = {
  class: "h-12 bg-white border-b border-slate-200 px-4 flex items-center justify-between shrink-0"
};
const _hoisted_38 = {
  class: "flex-1 flex overflow-hidden"
};
const _hoisted_39 = {
  class: "w-56 bg-white border-r border-slate-200 flex flex-col shadow-sm shrink-0"
};
const _hoisted_40 = {
  class: "flex-1 overflow-y-auto p-3"
};
const _hoisted_41 = {
  class: "space-y-2"
};
const _hoisted_42 = ["onDragstart"];
const _hoisted_43 = {
  class: "flex-1 min-w-0"
};
const _hoisted_44 = {
  class: "text-sm font-medium text-slate-700 group-hover:text-slate-900"
};
const _hoisted_45 = {
  class: "text-xs text-slate-400 truncate"
};
const _hoisted_46 = {
  class: "mt-6 p-3 bg-primary-50 rounded-lg border border-primary-100"
};
const _hoisted_47 = {
  class: "flex items-start gap-2"
};
const _hoisted_48 = {
  class: "flex-1 flex flex-col min-h-0 bg-slate-100/50"
};
const _hoisted_49 = {
  class: "absolute top-4 left-4 z-20 flex flex-col gap-2"
};
const _hoisted_50 = {
  class: "bg-white/95 backdrop-blur-sm rounded-xl shadow-lg border border-slate-200/60 p-1.5 flex flex-col gap-1"
};
const _hoisted_51 = {
  class: "absolute inset-0 pointer-events-none",
  style: {
    "width": "100%",
    "height": "100%"
  }
};
const _hoisted_52 = {
  class: "absolute inset-0 pointer-events-none",
  style: {
    "width": "100%",
    "height": "100%",
    "overflow": "visible"
  }
};
const _hoisted_53 = ["d"];
const _hoisted_54 = ["d", "stroke", "stroke-width", "marker-end", "onClick", "onContextmenu"];
const _hoisted_55 = ["onClick"];
const _hoisted_56 = ["x", "y"];
const _hoisted_57 = ["x", "y"];
const _hoisted_58 = ["data-node-id", "onMousedown", "onClick", "onContextmenu"];
const _hoisted_59 = {
  class: "text-sm font-semibold truncate max-w-[120px]"
};
const _hoisted_60 = {
  key: 0,
  class: "px-4 py-3 text-xs space-y-2 bg-slate-50/50 rounded-b-lg"
};
const _hoisted_61 = {
  key: 0,
  class: "flex items-center gap-2 text-slate-600"
};
const _hoisted_62 = {
  key: 1,
  class: "space-y-1.5"
};
const _hoisted_63 = {
  class: "w-4 h-4 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-[9px] font-bold"
};
const _hoisted_64 = {
  class: "text-slate-600 truncate"
};
const _hoisted_65 = {
  key: 0,
  class: "text-slate-400 text-xs pl-5"
};
const _hoisted_66 = {
  key: 2,
  class: "flex items-center gap-2 text-slate-600"
};
const _hoisted_67 = ["onMousedown"];
const _hoisted_68 = ["title", "onMousedown"];
const _hoisted_69 = {
  class: "branch-handle-label"
};
const _hoisted_70 = ["onMousedown"];
const _hoisted_71 = {
  class: "h-8 bg-white border-t border-slate-200 px-4 flex items-center justify-between text-xs text-slate-500 shrink-0"
};
const _hoisted_72 = {
  class: "flex items-center gap-4"
};
const _hoisted_73 = {
  class: "text-slate-700"
};
const _hoisted_74 = {
  class: "text-slate-700"
};
const _hoisted_75 = {
  class: "flex items-center gap-2"
};
const _hoisted_76 = {
  key: 0,
  class: "text-primary-600"
};
const _hoisted_77 = {
  key: 1,
  class: "text-primary-600"
};
const _hoisted_78 = {
  key: 2
};
const _hoisted_79 = {
  key: 0,
  class: "w-80 bg-white border-l border-slate-200 flex flex-col shadow-sm shrink-0"
};
const _hoisted_80 = {
  class: "px-4 py-3 border-b border-slate-200 bg-slate-50/50 flex items-center justify-between shrink-0"
};
const _hoisted_81 = {
  class: "flex items-center gap-2"
};
const _hoisted_82 = {
  class: "text-sm font-semibold text-slate-700"
};
const _hoisted_83 = {
  class: "flex-1 overflow-y-auto"
};
const _hoisted_84 = {
  class: "flex items-center gap-3 p-3 bg-slate-50 rounded-lg"
};
const _hoisted_85 = {
  class: "font-medium text-slate-800"
};
const _hoisted_86 = {
  class: "text-xs text-slate-500"
};
const _hoisted_87 = {
  key: 1,
  class: "space-y-3 rounded-lg border border-slate-200 bg-slate-50 p-3 mb-3"
};
const _hoisted_88 = {
  class: "grid grid-cols-2 gap-2"
};
const _hoisted_89 = {
  key: 2,
  class: "mb-3 p-3 bg-slate-50 rounded-lg text-sm text-slate-600"
};
const _hoisted_90 = {
  class: "grid grid-cols-2 gap-3"
};
const _hoisted_91 = {
  key: 0,
  class: "mb-3 p-3 bg-amber-50 border border-amber-200 rounded-lg"
};
const _hoisted_92 = {
  class: "flex items-start gap-2"
};
const _hoisted_93 = {
  key: 1,
  class: "mb-3 p-2.5 bg-emerald-50 border border-emerald-200 rounded-lg"
};
const _hoisted_94 = {
  class: "flex items-center gap-2 text-xs text-emerald-700"
};
const _hoisted_95 = {
  class: "flex items-center justify-between mb-2"
};
const _hoisted_96 = {
  class: "text-xs font-medium text-slate-700 flex items-center gap-1.5"
};
const _hoisted_97 = {
  class: "w-5 h-5 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-[10px] font-bold"
};
const _hoisted_98 = {
  class: "grid grid-cols-2 gap-2"
};
const _hoisted_99 = {
  key: 1,
  class: "space-y-3 rounded-lg border border-slate-200 bg-slate-50 p-3 mb-3"
};
const _hoisted_100 = {
  class: "grid grid-cols-2 gap-2"
};
const _hoisted_101 = {
  class: "p-3 bg-slate-50 rounded-lg"
};
const _hoisted_102 = {
  class: "flex items-center justify-between text-sm"
};
const _hoisted_103 = {
  class: "text-slate-700 font-mono text-xs"
};
const _hoisted_104 = {
  class: "grid grid-cols-2 gap-3"
};
import { ref, reactive, computed, onMounted, onUnmounted, nextTick, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { Plus, Check, Connection, Document, Close, RefreshLeft, RefreshRight, ZoomIn, ZoomOut, FullScreen, Grid, User, Message, Delete, DocumentCopy, DocumentAdd, ArrowLeft, Remove, Rank, MoreFilled, InfoFilled, WarningFilled, CircleCheck, Setting, Edit, Right, TrendCharts } from '@element-plus/icons-vue';
import FormDesigner from './FormDesigner.vue';
import ExportLayoutDesigner from './ExportLayoutDesigner.vue';
import StatsConfigEditor from './StatsConfigEditor.vue';
import { validateExportLayout } from '@/utils/workflowExportLayout';
import { validateStatsConfig } from '@/utils/workflowStatsConfig';
import UserSelector from '@/components/UserSelector/index.vue';
import DeptSelector from '@/components/DeptSelector/index.vue';
import { getWorkflowCategories, createTemplate, updateTemplate, getTemplateDetail } from '@/api/flow';
import { getRoles } from '@/api/role';
import { getDept } from '@/api/dept';
export default {
  __name: 'WorkflowDesigner',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();

    // 节点类型定义
    const nodeTypes = [{
      type: 'START',
      label: '开始',
      description: '流程起点',
      icon: Plus,
      bgClass: 'bg-green-100',
      iconClass: 'text-green-600'
    }, {
      type: 'APPROVAL',
      label: '审批',
      description: '审批节点',
      icon: Check,
      bgClass: 'bg-blue-100',
      iconClass: 'text-blue-600'
    }, {
      type: 'CONDITION',
      label: '条件分支',
      description: '条件判断',
      icon: Connection,
      bgClass: 'bg-orange-100',
      iconClass: 'text-orange-600'
    }, {
      type: 'CC',
      label: '抄送',
      description: '知会抄送',
      icon: Document,
      bgClass: 'bg-purple-100',
      iconClass: 'text-purple-600'
    }, {
      type: 'END',
      label: '结束',
      description: '流程终点',
      icon: Close,
      bgClass: 'bg-red-100',
      iconClass: 'text-red-600'
    }];

    // 画布引用
    const participantModeLabels = {
      USER: '指定用户',
      ROLE: '指定角色',
      DEPT_LEADER: '部门负责人',
      INITIATOR_MANAGER: '发起人主管',
      STARTER_SELECTED: '发起人自选'
    };
    function normalizeParticipantMode(mode) {
      return mode === 'DYNAMIC' ? 'STARTER_SELECTED' : mode;
    }
    function ensureSelectionDefaults(node) {
      if (!node?.config) return;
      const isApproval = node.type === 'APPROVAL';
      if (node.config.selectionRequired === undefined || node.config.selectionRequired === null) {
        node.config.selectionRequired = isApproval;
      }
      if (node.config.minSelect === undefined || node.config.minSelect === null) {
        node.config.minSelect = isApproval ? 1 : 0;
      }
      if (node.config.maxSelect === undefined || node.config.maxSelect === null) {
        node.config.maxSelect = isApproval ? 1 : 10;
      }
      if (node.config.allowApplicant === undefined || node.config.allowApplicant === null) {
        node.config.allowApplicant = !isApproval;
      }
    }
    function ensureStarterSelectedDefaults(node) {
      if (!node?.config) return;
      node.config.approverMode = normalizeParticipantMode(node.config.approverMode);
      if (node.config.approverMode === 'STARTER_SELECTED') {
        node.config.selectionEnabled = true;
        ensureSelectionDefaults(node);
        return;
      }
      if (node.config.selectionEnabled === undefined || node.config.selectionEnabled === null) {
        node.config.selectionEnabled = false;
      }
      if (node.config.selectionEnabled) {
        ensureSelectionDefaults(node);
      }
    }
    function shouldRenderStarterSelectionPanel(node) {
      if (!node?.config) return false;
      const mode = normalizeParticipantMode(node.config.approverMode);
      return mode === 'STARTER_SELECTED' || ['USER', 'ROLE', 'DEPT_LEADER'].includes(mode);
    }
    function shouldShowStarterSelectionConfig(node) {
      if (!node?.config) return false;
      const mode = normalizeParticipantMode(node.config.approverMode);
      return mode === 'STARTER_SELECTED' || Boolean(node.config.selectionEnabled);
    }
    function shouldShowAutomaticParticipantInfo(node) {
      if (!node?.config) return false;
      const mode = normalizeParticipantMode(node.config.approverMode);
      return ['DEPT_LEADER', 'INITIATOR_MANAGER'].includes(mode);
    }
    function normalizeParticipantApproverValue(value) {
      if (value === null || value === undefined) return '';
      if (Array.isArray(value)) {
        return value.map(item => item?.id ?? item?.value ?? item).filter(item => item !== null && item !== undefined && item !== '').join(',');
      }
      return String(value);
    }
    function normalizeParticipantNodeForSave(node) {
      if (!node?.config) return node;
      const config = {
        ...node.config
      };
      const normalizedMode = normalizeParticipantMode(config.approverMode);
      const requiresSelectionConfig = normalizedMode === 'STARTER_SELECTED' || Boolean(config.selectionEnabled);
      return {
        ...node,
        config: {
          ...config,
          approverMode: normalizedMode,
          approverValue: normalizeParticipantApproverValue(config.approverValue),
          selectionEnabled: normalizedMode === 'STARTER_SELECTED' ? true : Boolean(config.selectionEnabled),
          selectionRequired: requiresSelectionConfig ? Boolean(config.selectionRequired) : config.selectionRequired,
          allowApplicant: requiresSelectionConfig ? Boolean(config.allowApplicant) : config.allowApplicant
        }
      };
    }
    function normalizeLoadedParticipantNodes() {
      nodes.value.forEach(ensureStarterSelectedDefaults);
    }
    const canvasRef = ref(null);
    const canvasContainerRef = ref(null);

    // 流程基本信息
    const workflowId = ref(route.query.id || null);
    const workflowStatus = ref('draft');

    // 步骤控制
    const currentStep = ref(0);
    const basicInfoFormRef = ref(null);

    // 流程表单数据（整合三步）
    const workflowFormData = reactive({
      code: '',
      name: '',
      categoryId: null,
      description: '',
      icon: '',
      form: {
        name: '',
        fields: []
      },
      nodes: [],
      edges: [],
      exportLayout: null,
      statsConfig: null
    });

    // 基本信息验证规则
    const basicInfoRules = {
      name: [{
        required: true,
        message: '请输入流程名称',
        trigger: 'blur'
      }, {
        min: 2,
        max: 50,
        message: '流程名称长度为2-50个字符',
        trigger: 'blur'
      }],
      categoryId: [{
        required: true,
        message: '请选择流程分类',
        trigger: 'change'
      }]
    };

    // 分类列表
    const categoryList = ref([]);
    const categoryLoading = ref(false);

    // 表单字段数量
    const formFieldCount = computed(() => {
      return workflowFormData.form?.fields?.length || 0;
    });
    function generateWorkflowCode() {
      return `WF_${Date.now()}_${Math.random().toString(36).slice(2, 8).toUpperCase()}`;
    }
    function ensureWorkflowCode() {
      if (!workflowFormData.code) {
        workflowFormData.code = generateWorkflowCode();
      }
    }

    // 加载分类列表
    async function loadCategoryList() {
      categoryLoading.value = true;
      try {
        const res = await getWorkflowCategories();
        const list = res.data || res || [];
        // 统一字段名，添加 name 字段方便模板使用
        categoryList.value = list.map(cat => ({
          ...cat,
          id: cat.id,
          name: cat.categoryName
        }));
      } catch (error) {
        console.error('加载分类失败:', error);
        ElMessage.error('加载分类失败');
      } finally {
        categoryLoading.value = false;
      }
    }

    // 下一步
    async function nextStep() {
      if (currentStep.value === 0) {
        // 验证基本信息
        if (!basicInfoFormRef.value) return;
        try {
          await basicInfoFormRef.value.validate();
        } catch {
          return;
        }
      }

      // 从步骤2进入步骤3时，同步表单字段到可用字段列表（导出设计面板同步骤内复用该数据）
      if (currentStep.value === 1 && currentStep.value < 2) {
        // 如果 FormDesigner ref 存在，获取最新字段数据
        if (formDesignerRef.value) {
          const fieldList = formDesignerRef.value.getFieldList();
          if (fieldList && fieldList.length > 0) {
            availableFields.value = buildConditionFields(fieldList);
          }
        }
        // 同时也更新 workflowFormData.form
        if (formDesignerRef.value) {
          workflowFormData.form = formDesignerRef.value.getFormData();
        }
      }
      if (currentStep.value < 2) {
        currentStep.value++;
      }
    }

    // 上一步
    function prevStep() {
      if (currentStep.value > 0) {
        currentStep.value--;
      }
    }

    // 画布状态
    const zoom = ref(1);
    const panOffset = reactive({
      x: 0,
      y: 0
    });
    const panMode = ref(false);
    let spaceKeyPressed = false; // 全局空格键状态
    const isPanning = ref(false);
    const panStart = reactive({
      x: 0,
      y: 0
    });

    // 键盘事件处理函数
    function onKeyDown(e) {
      if (e.code === 'Space' && !e.repeat) {
        e.preventDefault();
        spaceKeyPressed = true;
      }
    }
    function onKeyUp(e) {
      if (e.code === 'Space') {
        e.preventDefault();
        spaceKeyPressed = false;
      }
    }
    function onWindowBlur() {
      spaceKeyPressed = false;
    }

    // 节点和连线
    const nodes = ref([]);
    const edges = ref([]);
    const selectedNode = ref(null);
    const selectedEdge = ref(null);
    function hasEdgeId(edge) {
      return edge && edge.id !== undefined && edge.id !== null && `${edge.id}` !== '';
    }
    function isSameEdge(a, b) {
      if (!a || !b) return false;
      if (hasEdgeId(a) && hasEdgeId(b)) {
        return String(a.id) === String(b.id);
      }
      return a.source === b.source && a.target === b.target && (a.branchIndex ?? null) === (b.branchIndex ?? null);
    }
    function getEdgeKey(edge, index) {
      if (hasEdgeId(edge)) {
        return `edge-id-${edge.id}`;
      }
      const branch = edge?.branchIndex ?? 'main';
      return `edge-${edge?.source || 'unknown'}-${edge?.target || 'unknown'}-${branch}-${index}`;
    }
    function isEdgeSelected(edge) {
      return isSameEdge(edge, selectedEdge.value);
    }
    function normalizeEdge(edge, index) {
      if (!edge || typeof edge !== 'object') return null;
      const source = edge.source ?? edge.sourceNodeId ?? edge.from ?? edge.fromNodeId;
      const target = edge.target ?? edge.targetNodeId ?? edge.to ?? edge.toNodeId;
      if (!source || !target) return null;
      return {
        ...edge,
        id: hasEdgeId(edge) ? String(edge.id) : `edge_${Date.now()}_${index}_${Math.random().toString(36).slice(2, 7)}`,
        source,
        target,
        label: edge.label || ''
      };
    }
    function normalizeEdges(rawEdges) {
      if (!Array.isArray(rawEdges)) return [];
      return rawEdges.map((edge, index) => normalizeEdge(edge, index)).filter(Boolean);
    }

    // 审批人/抄送方式变更时加载数据
    function onApproverModeChange(mode) {
      if (!selectedNode.value?.config) return;
      selectedNode.value.config.approverMode = normalizeParticipantMode(mode);
      if (selectedNode.value.config.approverMode === 'ROLE') {
        loadRoleList();
      } else if (selectedNode.value.config.approverMode === 'STARTER_SELECTED') {
        selectedNode.value.config.approverValue = '';
        selectedNode.value.config.selectionEnabled = true;
        ensureSelectionDefaults(selectedNode.value);
        return;
      }
      if (selectedNode.value.config.selectionEnabled === undefined || selectedNode.value.config.selectionEnabled === null) {
        selectedNode.value.config.selectionEnabled = false;
      }
    }
    function onSupplementSelectionToggle(enabled) {
      if (!selectedNode.value?.config) return;
      selectedNode.value.config.selectionEnabled = Boolean(enabled);
      if (selectedNode.value.config.selectionEnabled) {
        ensureSelectionDefaults(selectedNode.value);
      }
    }
    function resolveParticipantValueItem(item, mode) {
      const id = item?.id ?? item?.value ?? item;
      const label = item?.label ?? item?.name;
      if (id === null || id === undefined || id === '') return null;
      if (mode === 'ROLE') {
        const role = roleList.value.find(r => r.id == id || r.value == id);
        return role ? {
          id: role.id,
          label: role.label,
          value: role.id
        } : {
          id,
          label: label || String(id),
          value: id
        };
      }
      return {
        id,
        label: label || String(id),
        value: id
      };
    }

    // 审批人/抄送人值计算属性（支持多选，存储对象以显示名称）
    const approverValueArray = computed({
      get() {
        const value = selectedNode.value?.config?.approverValue;
        const mode = selectedNode.value?.config?.approverMode;
        if (!value) return [];
        const rawItems = Array.isArray(value) ? value : String(value).split(',');
        return rawItems.map(item => resolveParticipantValueItem(item, mode)).filter(Boolean);
      },
      set(val) {
        if (Array.isArray(val)) {
          // 提取 ID 用逗号拼接保存
          selectedNode.value.config.approverValue = val.map(item => item.id || item).join(',');
        } else {
          selectedNode.value.config.approverValue = val;
        }
      }
    });

    // 用户ID数组（用于 UserSelector 组件，仅存储ID）
    const approverUserIds = computed({
      get() {
        const value = selectedNode.value?.config?.approverValue;
        if (!value) return [];
        const rawItems = Array.isArray(value) ? value : String(value).split(',');
        return rawItems.map(item => {
          const id = item?.id ?? item?.value ?? item;
          return id === null || id === undefined || id === '' ? null : Number(id);
        }).filter(id => id !== null && !Number.isNaN(id));
      },
      set(val) {
        if (Array.isArray(val)) {
          selectedNode.value.config.approverValue = val.map(id => id).join(',');
        } else {
          selectedNode.value.config.approverValue = val;
        }
      }
    });

    // 部门负责人选择（DeptSelector 单选为 {id,name} 对象，存储纯 id；名称按需异步补拉）
    const deptLeaderNameCache = reactive({});
    const deptLeaderSelection = computed({
      get() {
        const value = selectedNode.value?.config?.approverValue;
        if (!value) return null;
        const raw = Array.isArray(value) ? value[0] : String(value).split(',')[0];
        const id = raw?.id ?? raw?.value ?? raw;
        if (id === null || id === undefined || id === '') return null;
        return {
          id,
          name: deptLeaderNameCache[id] || ''
        };
      },
      set(val) {
        const id = val ? typeof val === 'object' ? val.id : val : '';
        if (val && typeof val === 'object' && val.name) {
          deptLeaderNameCache[val.id] = val.name;
        }
        selectedNode.value.config.approverValue = id === null || id === undefined ? '' : String(id);
      }
    });

    // 已选部门名称异步补拉（编辑已有节点时 approverValue 只有 id）
    watch(() => deptLeaderSelection.value?.id, async id => {
      if (!id || deptLeaderNameCache[id]) return;
      try {
        const dept = await getDept(id);
        if (dept?.name) {
          deptLeaderNameCache[id] = dept.name;
        }
      } catch (error) {
        console.error('加载部门信息失败:', error);
      }
    }, {
      immediate: true
    });

    // 拖拽状态
    const isDraggingNode = ref(false);
    const dragNode = ref(null);
    const dragStart = reactive({
      x: 0,
      y: 0
    });

    // 连线创建状态
    const tempEdge = ref(null);
    const connectingNode = ref(null);
    const connectingHandle = ref(null);

    // 历史记录
    const historyStack = ref([]);
    const historyIndex = ref(-1);

    // 右键菜单
    const contextMenu = reactive({
      visible: false,
      x: 0,
      y: 0,
      type: null,
      target: null
    });

    // 复制粘贴
    const copiedNode = ref(null);

    // 表单设计器
    const formDesignerVisible = ref(false);
    const formDesignerRef = ref(null);
    const formDesignerKey = ref(0); // 用于强制刷新表单设计器

    // 导出设计器（第二步表单设计内嵌，由"生成导出单据"开关控制展示）
    const exportLayoutDesignerRef = ref(null);
    const exportEnabled = ref(false);

    // 加载回填期间抑制下方开关 watch 的兜底同步：loadWorkflow 回填时开关翻转触发的 watcher
    // 在 pre flush 中先于 FormDesigner 的 initialForm 同步执行，此时 getFormData() 读到的是
    // 挂载初始的空表单，会把刚回填好的 workflowFormData.form 覆盖为空
    let formBackfilling = false;

    // 开启"生成导出单据"时兜底同步一次表单字段，保证刚加的字段立即出现在导出设计器字段面板
    watch(exportEnabled, enabled => {
      if (enabled && !formBackfilling && formDesignerRef.value) {
        workflowFormData.form = formDesignerRef.value.getFormData();
      }
    });

    // 统计导出配置（第二步表单设计内嵌，由"统计导出"开关控制展示，与单据导出开关互相独立）
    const statsConfigEditorRef = ref(null);
    const statsEnabled = ref(false);

    // 开启"统计导出"时兜底同步一次表单字段，保证配置项候选数据最新
    watch(statsEnabled, enabled => {
      if (enabled && !formBackfilling && formDesignerRef.value) {
        workflowFormData.form = formDesignerRef.value.getFormData();
      }
    });

    // 导出设计 Tab（单据/统计共用面板，Tab 页签常驻挂载保持各自编辑状态）
    const exportDesignTab = ref('doc');

    // 可用字段（从表单字段动态生成）
    const availableFields = ref([]);

    // 条件分支可用字段：排除 DETAIL 容器本身，展开其 summary[].targetKey 作为数值虚拟字段（spec 5.2）
    function buildConditionFields(fields) {
      const result = [];
      (fields || []).forEach(field => {
        if (field.type === 'DETAIL') {
          (field.summary || []).forEach(sum => {
            if (sum.targetKey) {
              result.push({
                key: sum.targetKey,
                label: `${field.label}·${sum.label || sum.targetKey}`,
                type: 'NUMBER'
              });
            }
          });
          return;
        }
        result.push({
          key: field.key,
          label: field.label,
          type: field.type
        });
      });
      return result;
    }

    // 用户和角色列表
    const roleList = ref([]);
    const roleLoading = ref(false);

    // 对话框
    const saving = ref(false);

    // 加载角色列表
    async function loadRoleList() {
      roleLoading.value = true;
      try {
        const res = await getRoles({
          status: 0
        });
        // res 是数组格式
        const list = Array.isArray(res) ? res : res.records || [];
        roleList.value = list.map(role => ({
          id: role.id,
          label: role.name,
          value: role.id
        }));
      } catch (error) {
        console.error('加载角色列表失败:', error);
      } finally {
        roleLoading.value = false;
      }
    }

    // 计算属性
    const canUndo = computed(() => historyIndex.value > 0);
    const canRedo = computed(() => historyIndex.value < historyStack.value.length - 1);

    // 拖拽开始
    function onDragStart(event, nodeType) {
      event.dataTransfer.setData('nodeType', JSON.stringify(nodeType));
      event.dataTransfer.effectAllowed = 'copy';
    }

    // 放置节点
    function onDrop(event) {
      const nodeTypeData = event.dataTransfer.getData('nodeType');
      if (!nodeTypeData) return;
      const nodeType = JSON.parse(nodeTypeData);
      const rect = canvasContainerRef.value.getBoundingClientRect();
      const x = (event.clientX - rect.left - panOffset.x) / zoom.value;
      const y = (event.clientY - rect.top - panOffset.y) / zoom.value;
      const newNode = createNode(nodeType.type, x, y);
      saveHistory();
      nodes.value.push(newNode);
      selectedNode.value = newNode;
    }

    // 创建节点
    function createNode(type, x, y) {
      return {
        id: `node_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`,
        type,
        code: `${type.toLowerCase()}_${nodes.value.length + 1}`,
        label: getDefaultNodeLabel(type),
        x: Math.round(x),
        y: Math.round(y),
        config: createDefaultConfig(type),
        branches: type === 'CONDITION' ? createDefaultBranches() : null
      };
    }

    // 获取默认节点标签
    function getDefaultNodeLabel(type) {
      const labels = {
        START: '开始',
        APPROVAL: '审批节点',
        CONDITION: '条件分支',
        CC: '抄送',
        END: '结束'
      };
      return labels[type] || type;
    }

    // 创建默认配置
    function createDefaultConfig(type) {
      const config = {};
      if (type === 'APPROVAL') {
        config.approverMode = 'ROLE';
        config.approverValue = '';
        config.selectionEnabled = false;
        config.approvalMode = 'ANY';
        config.timeoutHours = 72;
        config.allowReject = true;
        config.allowDelegate = true;
      } else if (type === 'CC') {
        config.approverMode = 'ROLE';
        config.approverValue = '';
        config.selectionEnabled = false;
        config.notifyMode = 'BOTH';
      }
      return config;
    }

    // 创建默认分支
    function createDefaultBranches() {
      return [{
        label: '分支1',
        condition: {
          field: 'amount',
          operator: 'GTE',
          value: '1000'
        },
        targetNodeId: null
      }, {
        label: '分支2',
        condition: {
          field: 'amount',
          operator: 'LT',
          value: '1000'
        },
        targetNodeId: null
      }];
    }

    // 节点鼠标按下
    function onNodeMouseDown(event, node) {
      if (event.button !== 0) return; // 只处理左键

      isDraggingNode.value = true;
      dragNode.value = node;
      dragStart.x = event.clientX;
      dragStart.y = event.clientY;
      document.addEventListener('mousemove', onNodeMouseMove);
      document.addEventListener('mouseup', onNodeMouseUp);
    }

    // 节点拖拽移动
    function onNodeMouseMove(event) {
      if (!isDraggingNode.value || !dragNode.value) return;
      const dx = (event.clientX - dragStart.x) / zoom.value;
      const dy = (event.clientY - dragStart.y) / zoom.value;
      dragNode.value.x = Math.round(dragNode.value.x + dx);
      dragNode.value.y = Math.round(dragNode.value.y + dy);
      dragStart.x = event.clientX;
      dragStart.y = event.clientY;
    }

    // 节点拖拽结束
    function onNodeMouseUp() {
      if (isDraggingNode.value && dragNode.value) {
        saveHistory();
      }
      isDraggingNode.value = false;
      dragNode.value = null;
      document.removeEventListener('mousemove', onNodeMouseMove);
      document.removeEventListener('mouseup', onNodeMouseUp);
    }

    // 连接点鼠标按下
    function onHandleMouseDown(event, node, handleType, branchIndex = null) {
      event.stopPropagation();
      connectingNode.value = node;
      connectingHandle.value = handleType;
      tempEdge.value = {
        sourceNode: handleType === 'out' ? node : null,
        targetNode: handleType === 'in' ? node : null,
        branchIndex: branchIndex,
        mouseX: event.clientX,
        mouseY: event.clientY
      };
      document.addEventListener('mousemove', onHandleMouseMove);
      document.addEventListener('mouseup', onHandleMouseUp);
    }

    // 连接线拖拽移动
    function onHandleMouseMove(event) {
      if (!tempEdge.value) return;
      const rect = canvasContainerRef.value.getBoundingClientRect();
      tempEdge.value.mouseX = (event.clientX - rect.left - panOffset.x) / zoom.value;
      tempEdge.value.mouseY = (event.clientY - rect.top - panOffset.y) / zoom.value;
    }

    // 连接线拖拽结束
    function onHandleMouseUp(event) {
      if (!tempEdge.value) return;

      // 查找目标节点 - 先找包含 data-node-id 的父元素
      const nodeContainer = event.target.closest('[data-node-id]');
      if (nodeContainer) {
        const targetNodeId = nodeContainer.dataset.nodeId;
        const targetNode = nodes.value.find(n => n.id === targetNodeId);
        if (targetNode && targetNode.id !== connectingNode.value?.id) {
          // 创建连线
          const sourceNode = connectingHandle.value === 'out' ? connectingNode.value : targetNode;
          const destNode = connectingHandle.value === 'out' ? targetNode : connectingNode.value;
          const branchIndex = tempEdge.value.branchIndex;

          // 对于条件节点，检查该分支是否已有连线
          let canCreateEdge = true;
          let warningMsg = '';
          if (sourceNode.type === 'CONDITION' && branchIndex !== null) {
            // 检查该分支是否已有连线
            const existingEdge = edges.value.find(e => e.source === sourceNode.id && e.branchIndex === branchIndex);
            if (existingEdge) {
              canCreateEdge = false;
              warningMsg = `分支${branchIndex + 1}已有连线，请先删除原连线`;
            }
          } else {
            // 普通节点检查是否有重复连线
            const existingEdge = edges.value.find(e => e.source === sourceNode.id && e.target === destNode.id);
            if (existingEdge) {
              canCreateEdge = false;
              warningMsg = '该连线已存在';
            }
          }
          if (canCreateEdge) {
            saveHistory();
            const newEdge = {
              id: `edge_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`,
              source: sourceNode.id,
              target: destNode.id,
              label: ''
            };

            // 如果是条件节点的分支连线，记录分支索引和标签
            if (sourceNode.type === 'CONDITION' && branchIndex !== null) {
              newEdge.branchIndex = branchIndex;
              newEdge.label = sourceNode.branches[branchIndex]?.label || `分支${branchIndex + 1}`;

              // 同时更新条件节点的分支目标
              if (sourceNode.branches[branchIndex]) {
                sourceNode.branches[branchIndex].targetNodeId = destNode.id;
              }
            }
            edges.value.push(newEdge);
          } else {
            ElMessage.warning(warningMsg);
          }
        }
      }
      tempEdge.value = null;
      connectingNode.value = null;
      connectingHandle.value = null;
      document.removeEventListener('mousemove', onHandleMouseMove);
      document.removeEventListener('mouseup', onHandleMouseUp);
    }

    // 画布鼠标按下
    function onCanvasMouseDown(event) {
      if (event.button !== 0) return;
      // 支持点击拖拽模式按钮 或 按住空格键 + 鼠标拖拽
      const isPanMode = panMode.value || spaceKeyPressed;
      if (!isPanMode) return;
      // 检查是否点击在画布区域内
      if (!canvasContainerRef.value?.contains(event.target)) return;
      isPanning.value = true;
      panStart.x = event.clientX;
      panStart.y = event.clientY;
      document.addEventListener('mousemove', onCanvasMouseMove);
      document.addEventListener('mouseup', onCanvasMouseUp);
    }

    // 画布拖拽移动
    function onCanvasMouseMove(event) {
      if (!isPanning.value) return;
      const dx = event.clientX - panStart.x;
      const dy = event.clientY - panStart.y;
      panOffset.x += dx;
      panOffset.y += dy;
      panStart.x = event.clientX;
      panStart.y = event.clientY;
    }

    // 画布拖拽结束
    function onCanvasMouseUp() {
      isPanning.value = false;
      document.removeEventListener('mousemove', onCanvasMouseMove);
      document.removeEventListener('mouseup', onCanvasMouseUp);
    }

    // 画布滚轮事件 - 实现缩放和平移
    function onCanvasWheel(event) {
      event.preventDefault();
      if (event.ctrlKey || event.metaKey) {
        // Ctrl + 滚轮 = 缩放
        event.preventDefault();
        const delta = event.deltaY > 0 ? -0.1 : 0.1;
        zoom.value = Math.min(Math.max(zoom.value + delta, 0.3), 2);
      } else {
        // 普通滚轮 = 平移
        const deltaX = event.shiftKey ? event.deltaY : event.deltaX;
        const deltaY = event.shiftKey ? event.deltaX : event.deltaY;
        panOffset.x -= deltaX;
        panOffset.y -= deltaY;
      }
    }

    // 画布点击
    function onCanvasClick(event) {
      if (event.target === canvasRef.value || event.target.tagName === 'svg' || event.target.tagName === 'rect') {
        selectedNode.value = null;
        selectedEdge.value = null;
      }
    }

    // 选择节点
    function selectNode(node) {
      selectedNode.value = node;
      selectedEdge.value = null;
      closeContextMenu();

      // 加载角色列表（用于审批/抄送节点）
      if (node.type === 'APPROVAL' || node.type === 'CC') {
        loadRoleList();
      }

      // 确保条件节点有branches数组
      if (node.type === 'CONDITION') {
        if (!node.branches) {
          node.branches = createDefaultBranches();
        } else {
          // 确保每个分支都有完整的结构
          node.branches.forEach(branch => {
            if (!branch.label) branch.label = '';
            if (!branch.condition) {
              branch.condition = {
                field: '',
                operator: 'EQ',
                value: ''
              };
            } else {
              if (!branch.condition.field) branch.condition.field = '';
              if (!branch.condition.operator) branch.condition.operator = 'EQ';
              if (!branch.condition.value) branch.condition.value = '';
            }
            if (!branch.targetNodeId) branch.targetNodeId = null;
          });
        }
      }
    }

    // 选择连线
    function selectEdge(edge) {
      selectedEdge.value = edge;
      selectedNode.value = null;
      closeContextMenu();
    }

    // 关闭属性面板
    function closePropertyPanel() {
      selectedNode.value = null;
      selectedEdge.value = null;
    }

    // 删除节点
    function deleteNode() {
      if (!selectedNode.value) return;
      saveHistory();
      const nodeId = selectedNode.value.id;

      // 清除所有条件节点中指向被删除节点的 targetNodeId
      nodes.value.forEach(node => {
        if (node.type === 'CONDITION' && node.branches) {
          node.branches.forEach(branch => {
            if (branch.targetNodeId === nodeId) {
              branch.targetNodeId = null;
            }
          });
        }
      });
      nodes.value = nodes.value.filter(n => n.id !== nodeId);
      edges.value = edges.value.filter(e => e.source !== nodeId && e.target !== nodeId);
      selectedNode.value = null;
      closeContextMenu();
      ElMessage.success('节点已删除');
    }

    // 删除连线
    function deleteEdge() {
      if (!selectedEdge.value) return;
      saveHistory();

      // 如果是条件分支的连线，清除分支的 targetNodeId
      if (selectedEdge.value.branchIndex !== undefined) {
        const sourceNode = nodes.value.find(n => n.id === selectedEdge.value.source);
        if (sourceNode && sourceNode.branches && sourceNode.branches[selectedEdge.value.branchIndex]) {
          sourceNode.branches[selectedEdge.value.branchIndex].targetNodeId = null;
        }
      }
      edges.value = edges.value.filter(e => !isSameEdge(e, selectedEdge.value));
      selectedEdge.value = null;
      closeContextMenu();
      ElMessage.success('连线已删除');
    }

    // 添加分支
    function addBranch() {
      if (!selectedNode.value) return;

      // 确保 branches 数组存在
      if (!selectedNode.value.branches) {
        selectedNode.value.branches = [];
      }
      selectedNode.value.branches.push({
        label: `分支${selectedNode.value.branches.length + 1}`,
        condition: {
          field: '',
          operator: 'EQ',
          value: ''
        },
        targetNodeId: null
      });
    }

    // 删除分支
    function removeBranch(index) {
      if (!selectedNode.value || !selectedNode.value.branches) return;
      if (selectedNode.value.branches.length <= 1) {
        ElMessage.warning('至少保留一个分支');
        return;
      }
      selectedNode.value.branches.splice(index, 1);
    }

    // 复制节点
    function copyNode() {
      if (!selectedNode.value) return;
      copiedNode.value = JSON.parse(JSON.stringify(selectedNode.value));
      ElMessage.success('节点已复制');
      closeContextMenu();
    }

    // 粘贴节点
    function pasteNode() {
      if (!copiedNode.value) return;
      saveHistory();
      const newNode = {
        ...JSON.parse(JSON.stringify(copiedNode.value)),
        id: `node_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`,
        x: contextMenu.x - panOffset.x,
        y: contextMenu.y - panOffset.y
      };
      nodes.value.push(newNode);
      selectedNode.value = newNode;
      closeContextMenu();
      ElMessage.success('节点已粘贴');
    }

    // 右键菜单
    function onNodeContextMenu(event, node) {
      selectedNode.value = node;
      contextMenu.visible = true;
      contextMenu.x = event.clientX;
      contextMenu.y = event.clientY;
      contextMenu.type = 'node';
      contextMenu.target = node;
    }
    function onEdgeContextMenu(event, edge) {
      selectedEdge.value = edge;
      contextMenu.visible = true;
      contextMenu.x = event.clientX;
      contextMenu.y = event.clientY;
      contextMenu.type = 'edge';
      contextMenu.target = edge;
    }
    function onCanvasContextMenu(event) {
      if (event.target === canvasRef.value || event.target.tagName === 'svg') {
        contextMenu.visible = true;
        contextMenu.x = event.clientX;
        contextMenu.y = event.clientY;
        contextMenu.type = 'canvas';
        contextMenu.target = null;
      }
    }
    function closeContextMenu() {
      contextMenu.visible = false;
      contextMenu.type = null;
      contextMenu.target = null;
    }

    // 缩放
    function zoomIn() {
      zoom.value = Math.min(zoom.value + 0.1, 2);
    }
    function zoomOut() {
      zoom.value = Math.max(zoom.value - 0.1, 0.3);
    }
    function fitView() {
      if (nodes.value.length === 0) return;
      const padding = 50;
      const minX = Math.min(...nodes.value.map(n => n.x)) - padding;
      const minY = Math.min(...nodes.value.map(n => n.y)) - padding;
      const maxX = Math.max(...nodes.value.map(n => n.x + 160)) + padding;
      const maxY = Math.max(...nodes.value.map(n => n.y + 80)) + padding;
      const width = maxX - minX;
      const height = maxY - minY;
      const containerRect = canvasContainerRef.value.getBoundingClientRect();
      const scaleX = containerRect.width / width;
      const scaleY = containerRect.height / height;
      const newZoom = Math.min(scaleX, scaleY, 1);
      zoom.value = newZoom;
      panOffset.x = -minX * newZoom + (containerRect.width - width * newZoom) / 2;
      panOffset.y = -minY * newZoom + (containerRect.height - height * newZoom) / 2;
    }

    // 切换拖拽模式
    function togglePanMode() {
      panMode.value = !panMode.value;
    }

    // 自动布局
    function autoLayout() {
      if (nodes.value.length === 0) return;
      saveHistory();

      // 简单的层级布局
      const startNode = nodes.value.find(n => n.type === 'START');
      if (!startNode) return;
      const layers = [];
      const visited = new Set();

      // BFS分层
      const queue = [{
        node: startNode,
        layer: 0
      }];
      visited.add(startNode.id);
      while (queue.length > 0) {
        const {
          node,
          layer
        } = queue.shift();
        if (!layers[layer]) layers[layer] = [];
        layers[layer].push(node);
        const outEdges = edges.value.filter(e => e.source === node.id);
        outEdges.forEach(edge => {
          const targetNode = nodes.value.find(n => n.id === edge.target);
          if (targetNode && !visited.has(targetNode.id)) {
            visited.add(targetNode.id);
            queue.push({
              node: targetNode,
              layer: layer + 1
            });
          }
        });
      }

      // 布局节点
      const layerSpacing = 250;
      const nodeSpacing = 150;
      const startX = 100;
      const startY = 100;
      layers.forEach((layerNodes, layerIndex) => {
        const y = startY + layerIndex * layerSpacing;
        const totalWidth = (layerNodes.length - 1) * nodeSpacing;
        const x = startX;
        layerNodes.forEach((node, nodeIndex) => {
          node.x = x + nodeIndex * nodeSpacing - totalWidth / 2 + 300;
          node.y = y;
        });
      });
      ElMessage.success('自动布局完成');
      closeContextMenu();
    }

    // 历史记录
    function saveHistory() {
      historyStack.value = historyStack.value.slice(0, historyIndex.value + 1);
      historyStack.value.push(JSON.stringify({
        nodes: nodes.value,
        edges: edges.value
      }));
      historyIndex.value = historyStack.value.length - 1;

      // 限制历史记录数量
      if (historyStack.value.length > 50) {
        historyStack.value.shift();
        historyIndex.value--;
      }
    }
    function undo() {
      if (!canUndo.value) return;
      historyIndex.value--;
      const state = JSON.parse(historyStack.value[historyIndex.value]);
      nodes.value = state.nodes;
      edges.value = state.edges;
      selectedNode.value = null;
      selectedEdge.value = null;
    }
    function redo() {
      if (!canRedo.value) return;
      historyIndex.value++;
      const state = JSON.parse(historyStack.value[historyIndex.value]);
      nodes.value = state.nodes;
      edges.value = state.edges;
      selectedNode.value = null;
      selectedEdge.value = null;
    }

    // 应用表单字段到条件选项
    function applyFormFields() {
      if (!formDesignerRef.value) return;
      const fieldList = formDesignerRef.value.getFieldList();
      if (fieldList.length === 0) {
        ElMessage.warning('请先添加表单字段');
        return;
      }

      // 更新可用字段列表
      availableFields.value = buildConditionFields(fieldList);

      // 同时更新表单数据
      workflowForm.value = formDesignerRef.value.getFormData();
      formDesignerVisible.value = false;
      ElMessage.success(`已应用 ${fieldList.length} 个表单字段，现在可以在条件分支中使用这些字段`);
    }

    // 表单保存回调
    function onFormSave(formData) {
      workflowFormData.form = formData;

      // 自动同步字段到可用列表
      if (formData && formData.fields) {
        availableFields.value = buildConditionFields(formData.fields);

        // 如果当前已选中条件节点，刷新属性面板以更新字段列表
        nextTick(() => {
          if (selectedNode.value && selectedNode.value.type === 'CONDITION') {
            // 保存当前选中的节点ID
            const currentNodeId = selectedNode.value.id;
            // 先清空选择，触发面板关闭
            selectedNode.value = null;
            // 下一帧重新选中节点，触发面板重新渲染
            nextTick(() => {
              const node = nodes.value.find(n => n.id === currentNodeId);
              if (node) {
                selectedNode.value = node;
              }
            });
          }
        });
      }
    }

    // 验证流程配置
    function validateParticipantNode(node, label) {
      const mode = normalizeParticipantMode(node.config?.approverMode);
      if (!mode) return `${label}节点"${node.label}"未配置人员方式`;
      if (['USER', 'ROLE', 'DEPT_LEADER'].includes(mode) && !node.config?.approverValue) {
        return `${label}节点"${node.label}"未配置${label === '审批' ? '审批人' : '抄送人'}`;
      }
      const requiresSelectionConfig = mode === 'STARTER_SELECTED' || Boolean(node.config?.selectionEnabled);
      if (requiresSelectionConfig) {
        const min = Number(node.config.minSelect ?? (node.type === 'APPROVAL' ? 1 : 0));
        const max = node.config.maxSelect == null ? null : Number(node.config.maxSelect);
        if (node.type === 'APPROVAL' && mode === 'STARTER_SELECTED' && min < 1) {
          return `审批节点"${node.label}"发起人自选至少需要 1 人`;
        }
        if (max !== null && max > 0 && max < min) {
          return `${label}节点"${node.label}"最多人数不能小于最少人数`;
        }
      }
      if (mode === 'INITIATOR_MANAGER') return `${label}节点"${node.label}"的发起人主管模式暂未支持`;
      return '';
    }
    function validateFlowConfig() {
      const errors = [];

      // 检查是否有开始节点
      const startNodes = nodes.value.filter(n => n.type === 'START');
      if (startNodes.length === 0) {
        errors.push('流程必须包含一个开始节点');
      } else if (startNodes.length > 1) {
        errors.push('流程只能有一个开始节点');
      }

      // 检查是否有结束节点
      const endNodes = nodes.value.filter(n => n.type === 'END');
      if (endNodes.length === 0) {
        errors.push('流程必须包含至少一个结束节点');
      }

      // 检查节点配置
      nodes.value.forEach(node => {
        if (node.type === 'APPROVAL') {
          const error = validateParticipantNode(node, '审批');
          if (error) errors.push(error);
          if (['STARTER_SELECTED', 'INITIATOR_MANAGER'].includes(normalizeParticipantMode(node.config?.approverMode))) {
            return;
          }
          if (!node.config.approverValue) {
            errors.push(`审批节点"${node.label}"未配置审批人`);
          }
        }
        if (node.type === 'CONDITION') {
          if (!node.branches || node.branches.length < 2) {
            errors.push(`条件节点"${node.label}"至少需要2个分支`);
          }
        }
        if (node.type === 'CC') {
          const error = validateParticipantNode(node, '抄送');
          if (error) errors.push(error);
          if (['STARTER_SELECTED', 'INITIATOR_MANAGER'].includes(normalizeParticipantMode(node.config?.approverMode))) {
            return;
          }
          if (!node.config.approverValue) {
            errors.push(`抄送节点"${node.label}"未配置抄送人`);
          }
        }
      });

      // 检查孤立节点
      nodes.value.forEach(node => {
        if (node.type !== 'START' && node.type !== 'END') {
          const hasIncoming = edges.value.some(e => e.target === node.id);
          const hasOutgoing = edges.value.some(e => e.source === node.id);
          if (!hasIncoming && !hasOutgoing) {
            errors.push(`节点"${node.label}"没有连接到流程中`);
          }
        }
      });
      return errors;
    }

    // 保存
    async function save() {
      // 先验证基本信息
      if (!workflowFormData.name) {
        ElMessage.error('请填写流程名称');
        currentStep.value = 0;
        return;
      }
      if (!workflowFormData.categoryId) {
        ElMessage.error('请选择流程分类');
        currentStep.value = 0;
        return;
      }

      // 验证流程配置
      const flowErrors = validateFlowConfig();
      if (flowErrors.length > 0) {
        ElMessage.error(`流程验证失败：${flowErrors[0]}`);
        currentStep.value = 2;
        return;
      }

      // 校验导出布局（spec §3.2 同规则）：仅在"生成导出单据"开关开启时校验，
      // 失败时拦截并定位首个失效元素，跳回表单设计步骤
      let exportLayout = null;
      if (exportEnabled.value) {
        // 兜底同步最新表单字段（导出布局校验依赖字段面板数据）
        if (formDesignerRef.value) {
          workflowFormData.form = formDesignerRef.value.getFormData();
        }
        exportLayout = exportLayoutDesignerRef.value ? exportLayoutDesignerRef.value.getExportLayout() : workflowFormData.exportLayout;
        const exportLayoutError = validateExportLayout(exportLayout, workflowFormData.form?.fields);
        if (exportLayoutError) {
          ElMessage.error(exportLayoutError);
          currentStep.value = 1;
          exportDesignTab.value = 'doc';
          // 定位首个问题行（选中 + 滚动到可视区 + 高亮闪烁），便于用户直接修复
          exportLayoutDesignerRef.value?.locateError(exportLayoutError);
          return;
        }
      }

      // 校验统计配置（spec §4 同规则）：仅在"统计导出"开关开启时校验，
      // 失败时拦截并定位首个错误，跳回表单设计步骤（标黄项在此被拦下）
      let statsConfig = null;
      if (statsEnabled.value) {
        // 兜底同步最新表单字段（统计配置校验依赖字段候选数据）
        if (formDesignerRef.value) {
          workflowFormData.form = formDesignerRef.value.getFormData();
        }
        statsConfig = statsConfigEditorRef.value ? statsConfigEditorRef.value.getStatsConfig() : workflowFormData.statsConfig;
        const statsConfigError = validateStatsConfig(statsConfig, workflowFormData.form?.fields);
        if (statsConfigError) {
          ElMessage.error(statsConfigError);
          currentStep.value = 1;
          exportDesignTab.value = 'stats';
          return;
        }
      }
      saving.value = true;
      try {
        ensureWorkflowCode();
        // 同步流程图数据
        normalizeLoadedParticipantNodes();
        const normalizedNodes = nodes.value.map(normalizeParticipantNodeForSave);
        workflowFormData.nodes = normalizedNodes;
        workflowFormData.edges = edges.value;

        // 构建接口参数
        const saveData = {
          templateCode: workflowFormData.code,
          templateName: workflowFormData.name,
          description: workflowFormData.description || '',
          categoryId: workflowFormData.categoryId,
          formSchema: JSON.stringify(workflowFormData.form),
          graphData: JSON.stringify({
            nodes: normalizedNodes,
            edges: edges.value
          }),
          exportLayout: exportLayout ? JSON.stringify(exportLayout) : null,
          // stats_config 三态（spec §4 与后端 updateTemplate 语义一致）：
          // 开关开启 → JSON 串（校验+更新）；开关关闭 → 更新场景提交空白串显式清空（null=不动），新建场景提交 null
          statsConfig: statsConfig ? JSON.stringify(statsConfig) : workflowId.value ? '' : null
        };

        // 判断是新增还是更新
        if (workflowId.value) {
          // 更新已有流程
          await updateTemplate({
            templateId: workflowId.value,
            ...saveData
          });
          ElMessage.success('更新成功');
          router.push('/workflow/list');
        } else {
          // 创建新流程
          await createTemplate(saveData);
          ElMessage.success('保存成功');
          router.push('/workflow/list');
        }
      } catch (error) {
        console.error('保存失败:', error);
        ElMessage.error(error.message || '保存失败');
      } finally {
        saving.value = false;
      }
    }

    // 获取连线路径
    function getEdgePath(edge) {
      const sourceNode = nodes.value.find(n => n.id === edge.source);
      const targetNode = nodes.value.find(n => n.id === edge.target);
      if (!sourceNode || !targetNode) return '';
      const sx = sourceNode.x + getNodeWidth(sourceNode) / 2;
      const sy = sourceNode.y + 40;
      const tx = targetNode.x + getNodeWidth(targetNode) / 2;
      const ty = targetNode.y + 40;
      const midX = (sx + tx) / 2;
      return `M ${sx} ${sy} C ${midX} ${sy}, ${midX} ${ty}, ${tx} ${ty}`;
    }

    // 获取临时连线路径
    function getTempEdgePath() {
      if (!tempEdge.value) return '';
      const node = connectingNode.value;
      const nodeX = node.x + getNodeWidth(node) / 2;
      const nodeY = node.y + 40;
      const mouseX = tempEdge.value.mouseX;
      const mouseY = tempEdge.value.mouseY;
      const midX = (nodeX + mouseX) / 2;
      if (connectingHandle.value === 'out') {
        return `M ${nodeX} ${nodeY} C ${midX} ${nodeY}, ${midX} ${mouseY}, ${mouseX} ${mouseY}`;
      } else {
        return `M ${mouseX} ${mouseY} C ${midX} ${mouseY}, ${midX} ${nodeY}, ${nodeX} ${nodeY}`;
      }
    }

    // 获取连线标签位置
    function getEdgeLabelPosition(edge) {
      const sourceNode = nodes.value.find(n => n.id === edge.source);
      const targetNode = nodes.value.find(n => n.id === edge.target);
      if (!sourceNode || !targetNode) return {
        x: 0,
        y: 0
      };
      const sx = sourceNode.x + getNodeWidth(sourceNode) / 2;
      const sy = sourceNode.y + 40;
      const tx = targetNode.x + getNodeWidth(targetNode) / 2;
      const ty = targetNode.y + 40;
      return {
        x: (sx + tx) / 2,
        y: (sy + ty) / 2
      };
    }

    // 节点样式
    function getNodeClass(node) {
      const classes = {
        START: 'border-green-500',
        APPROVAL: 'border-blue-500',
        CONDITION: 'border-orange-500',
        CC: 'border-purple-500',
        END: 'border-red-500'
      };
      return classes[node.type] || 'border-slate-300';
    }
    function getNodeHeaderClass(node) {
      const classes = {
        START: 'bg-green-500 text-white',
        APPROVAL: 'bg-blue-500 text-white',
        CONDITION: 'bg-orange-500 text-white',
        CC: 'bg-purple-500 text-white',
        END: 'bg-red-500 text-white'
      };
      return classes[node.type] || 'bg-slate-500 text-white';
    }
    function getNodeIcon(type) {
      const node = nodeTypes.find(n => n.type === type);
      return node ? node.icon : Document;
    }
    function getNodeTypeLabel(type) {
      const node = nodeTypes.find(n => n.type === type);
      return node ? node.label : type;
    }
    function getNodeWidth(node) {
      return node.type === 'CONDITION' ? 180 : 160;
    }
    function hasNodeContent(node) {
      return ['APPROVAL', 'CONDITION', 'CC'].includes(node.type);
    }
    function getNodeLabel(nodeId) {
      const node = nodes.value.find(n => n.id === nodeId);
      return node ? node.label : '未知节点';
    }

    // 获取分支连接点位置
    function getBranchHandleStyle(node, branchIndex) {
      const totalBranches = node.branches?.length || 1;
      const nodeHeight = 60 + (hasNodeContent(node) ? 40 : 0);

      // 计算每个分支连接点的垂直位置
      const spacing = nodeHeight / (totalBranches + 1);
      const top = spacing * (branchIndex + 1);
      return {
        top: `${top}px`,
        right: '-7px'
      };
    }

    // 节点文本
    function getApproverText(node) {
      return participantModeLabels[normalizeParticipantMode(node.config.approverMode)] || '未配置';
    }
    function getCcText(node) {
      return participantModeLabels[normalizeParticipantMode(node.config.approverMode)] || '未配置';
    }

    // 节点背景样式
    function getNodeBgClass(type) {
      const classes = {
        START: 'bg-emerald-100',
        APPROVAL: 'bg-blue-100',
        CONDITION: 'bg-amber-100',
        CC: 'bg-violet-100',
        END: 'bg-rose-100'
      };
      return classes[type] || 'bg-slate-100';
    }

    // 节点图标样式
    function getNodeIconClass(type) {
      const classes = {
        START: 'text-emerald-600',
        APPROVAL: 'text-blue-600',
        CONDITION: 'text-amber-600',
        CC: 'text-violet-600',
        END: 'text-rose-600'
      };
      return classes[type] || 'text-slate-600';
    }

    // 状态标签
    function getStatusType(status) {
      const types = {
        draft: 'info',
        published: 'success',
        disabled: 'danger'
      };
      return types[status] || 'info';
    }
    function getStatusLabel(status) {
      const labels = {
        draft: '草稿',
        published: '已发布',
        disabled: '已停用'
      };
      return labels[status] || status;
    }
    const loading = ref(false);

    // 加载流程详情
    async function loadWorkflow() {
      if (!workflowId.value) return;
      loading.value = true;
      try {
        const data = await getTemplateDetail(workflowId.value);

        // 回填开始：抑制开关 watch 的兜底同步，避免读空表单覆盖回填结果
        formBackfilling = true;

        // 回填基本信息
        workflowFormData.code = data.templateCode || '';
        workflowFormData.name = data.templateName || '';
        workflowFormData.categoryId = data.categoryId || null;
        workflowFormData.description = data.description || '';

        // 回填表单设计
        if (data.formSchema) {
          try {
            const formSchema = typeof data.formSchema === 'string' ? JSON.parse(data.formSchema) : data.formSchema;
            workflowFormData.form = formSchema || {
              name: '',
              fields: []
            };

            // 同步可用字段
            if (formSchema && formSchema.fields) {
              availableFields.value = buildConditionFields(formSchema.fields);
            }
          } catch (e) {
            console.error('解析表单schema失败:', e);
            workflowFormData.form = {
              name: '',
              fields: []
            };
          }
        }

        // 回填导出设计布局
        if (data.exportLayout) {
          try {
            workflowFormData.exportLayout = typeof data.exportLayout === 'string' ? JSON.parse(data.exportLayout) : data.exportLayout;
          } catch (e) {
            console.error('解析导出布局失败:', e);
            workflowFormData.exportLayout = null;
          }
        } else {
          workflowFormData.exportLayout = null;
        }
        // 模板已配置导出布局则开启"生成导出单据"开关，否则关闭
        exportEnabled.value = !!workflowFormData.exportLayout;

        // 回填统计导出配置
        if (data.statsConfig && String(data.statsConfig).trim() !== '') {
          try {
            workflowFormData.statsConfig = typeof data.statsConfig === 'string' ? JSON.parse(data.statsConfig) : data.statsConfig;
          } catch (e) {
            console.error('解析统计配置失败:', e);
            workflowFormData.statsConfig = null;
          }
        } else {
          workflowFormData.statsConfig = null;
        }
        // 模板已配置统计导出则开启"统计导出"开关，否则关闭（与单据导出开关互相独立）
        statsEnabled.value = !!workflowFormData.statsConfig;

        // 回填流程图数据
        if (data.graphData) {
          try {
            const graphData = typeof data.graphData === 'string' ? JSON.parse(data.graphData) : data.graphData;
            nodes.value = graphData.nodes || [];
            normalizeLoadedParticipantNodes();
            edges.value = normalizeEdges(graphData.edges || []);
          } catch (e) {
            console.error('解析流程图数据失败:', e);
            // 如果解析失败，初始化默认的开始和结束节点
            nodes.value = [createNode('START', 150, 150), createNode('END', 800, 150)];
            edges.value = [];
          }
        }

        // 更新流程状态
        workflowStatus.value = data.status || 'draft';

        // 强制刷新表单设计器以回显数据
        formDesignerKey.value++;

        // 等本轮 flush 中排队的开关 watcher 执行完毕后再解除抑制（pre flush 先于 nextTick 回调）
        await nextTick();
        formBackfilling = false;

        // 如果有mode参数且为view，设置只读模式
        const mode = route.query.mode;
        if (mode === 'view') {
          ElMessage.info('当前为查看模式，无法编辑');
        }
      } catch (error) {
        formBackfilling = false;
        console.error('加载流程数据失败:', error);
        ElMessage.error(error.message || '加载流程数据失败');
      } finally {
        loading.value = false;
      }
    }

    // 点击外部关闭菜单
    function handleClickOutside() {
      if (contextMenu.visible) {
        closeContextMenu();
      }
    }

    // 初始化
    onMounted(async () => {
      // 加载分类列表
      await loadCategoryList();

      // 预加载角色列表（用于审批/抄送节点）
      loadRoleList();

      // 初始化开始和结束节点（仅在新建流程时）
      if (!workflowId.value && nodes.value.length === 0) {
        nodes.value = [createNode('START', 150, 150), createNode('END', 800, 150)];
        // 保存初始状态
        saveHistory();
      }

      // 监听点击外部
      document.addEventListener('click', handleClickOutside);

      // 监听空格键状态 - 用于拖拽画布
      document.addEventListener('keydown', onKeyDown);
      document.addEventListener('keyup', onKeyUp);
      window.addEventListener('blur', onWindowBlur);

      // 如果有id参数,加载流程数据
      if (workflowId.value) {
        await loadWorkflow();
        // 加载后保存初始状态用于撤销
        saveHistory();
      }
    });
    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('keyup', onKeyUp);
      window.removeEventListener('blur', onWindowBlur);
      document.removeEventListener('mousemove', onNodeMouseMove);
      document.removeEventListener('mouseup', onNodeMouseUp);
      document.removeEventListener('mousemove', onHandleMouseMove);
      document.removeEventListener('mouseup', onHandleMouseUp);
      document.removeEventListener('mousemove', onCanvasMouseMove);
      document.removeEventListener('mouseup', onCanvasMouseUp);
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_step = _resolveComponent("el-step");
      const _component_el_steps = _resolveComponent("el-steps");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_button_group = _resolveComponent("el-button-group");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).back()),
        class: "p-1.5 rounded-lg hover:bg-slate-100 transition-colors"
      }, [_createVNode(_component_el_icon, {
        size: 18
      }, {
        default: _withCtx(() => [_createVNode(_unref(ArrowLeft))]),
        _: 1
      })]), _createVNode(_component_el_divider, {
        direction: "vertical",
        class: "!my-1 !h-6"
      }), _createElementVNode("h1", _hoisted_4, _toDisplayString(workflowFormData.name || '未命名流程'), 1), workflowStatus.value ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 0,
        type: getStatusType(workflowStatus.value),
        size: "small"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(getStatusLabel(workflowStatus.value)), 1)]),
        _: 1
      }, 8, ["type"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_steps, {
        active: currentStep.value,
        "align-center": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_step, {
          title: "基本信息"
        }), _createVNode(_component_el_step, {
          title: "表单设计"
        }), _createVNode(_component_el_step, {
          title: "流程设计"
        })]),
        _: 1
      }, 8, ["active"])]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_icon, {
        size: 16,
        class: "text-primary-600"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Edit))]),
        _: 1
      })]), _cache[35] || (_cache[35] = _createElementVNode("div", null, [_createElementVNode("h2", {
        class: "text-base font-semibold text-slate-800"
      }, "流程基本信息"), _createElementVNode("p", {
        class: "text-xs text-slate-500"
      }, "设置流程的名称、分类和描述")], -1))]), _createVNode(_component_el_form, {
        ref_key: "basicInfoFormRef",
        ref: basicInfoFormRef,
        model: workflowFormData,
        rules: basicInfoRules,
        "label-position": "top",
        class: "space-y-3"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "流程名称",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: workflowFormData.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => workflowFormData.name = $event),
            placeholder: "请输入流程名称",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "流程分类",
          prop: "categoryId"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: workflowFormData.categoryId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => workflowFormData.categoryId = $event),
            placeholder: "请选择流程分类",
            filterable: "",
            class: "w-full"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, cat => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: cat.id,
                label: cat.name,
                value: cat.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "流程描述",
          prop: "description"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: workflowFormData.description,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => workflowFormData.description = $event),
            type: "textarea",
            rows: 3,
            placeholder: "请输入流程描述，说明该流程的用途和适用范围",
            maxlength: "500",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "流程图标"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_icon, {
            size: 18,
            class: "text-slate-400"
          }, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          })]), _cache[36] || (_cache[36] = _createElementVNode("div", {
            class: "text-sm text-slate-500"
          }, [_createElementVNode("p", null, "支持上传 PNG、JPG 格式"), _createElementVNode("p", null, "建议尺寸: 64x64 像素")], -1))])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_button, {
        size: "small",
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).back())
      }, {
        default: _withCtx(() => [...(_cache[37] || (_cache[37] = [_createTextVNode("取消", -1)]))]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        onClick: nextStep
      }, {
        default: _withCtx(() => [_cache[38] || (_cache[38] = _createTextVNode(" 下一步：表单设计 ", -1)), _createVNode(_component_el_icon, {
          class: "ml-1"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Right))]),
          _: 1
        })]),
        _: 1
      })])])])], 512), [[_vShow, currentStep.value === 0]]), _withDirectives(_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [(_openBlock(), _createBlock(FormDesigner, {
        key: formDesignerKey.value,
        ref_key: "formDesignerRef",
        ref: formDesignerRef,
        "initial-form": workflowFormData.form,
        onSave: onFormSave
      }, null, 8, ["initial-form"])), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_tabs, {
        modelValue: exportDesignTab.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => exportDesignTab.value = $event),
        class: "export-design-tabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "导出单据",
          name: "doc"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_cache[40] || (_cache[40] = _createElementVNode("div", null, [_createElementVNode("h3", {
            class: "text-sm font-semibold text-slate-700"
          }, "导出单据"), _createElementVNode("p", {
            class: "text-xs text-slate-500 mt-0.5"
          }, "为审批通过的单据生成 Word 导出布局")], -1)), _createElementVNode("div", _hoisted_19, [_cache[39] || (_cache[39] = _createElementVNode("span", {
            class: "text-sm text-slate-600"
          }, "启用导出单据", -1)), _createVNode(_component_el_switch, {
            modelValue: exportEnabled.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => exportEnabled.value = $event)
          }, null, 8, ["modelValue"])])]), _withDirectives(_createElementVNode("div", _hoisted_20, [_createVNode(ExportLayoutDesigner, {
            ref_key: "exportLayoutDesignerRef",
            ref: exportLayoutDesignerRef,
            fields: workflowFormData.form?.fields || [],
            "initial-layout": workflowFormData.exportLayout
          }, null, 8, ["fields", "initial-layout"])], 512), [[_vShow, exportEnabled.value]]), _withDirectives(_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_icon, {
            size: 40,
            class: "text-slate-300 mb-3"
          }, {
            default: _withCtx(() => [_createVNode(_unref(Document))]),
            _: 1
          }), _cache[42] || (_cache[42] = _createElementVNode("p", {
            class: "text-sm font-medium text-slate-700 mb-1"
          }, "导出单据未启用", -1)), _cache[43] || (_cache[43] = _createElementVNode("p", {
            class: "text-xs text-slate-500 mb-4"
          }, "开启后可拖拽字段设计 Word 导出布局", -1)), _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _cache[6] || (_cache[6] = $event => exportEnabled.value = true)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "mr-1"
            }, {
              default: _withCtx(() => [_createVNode(_unref(Document))]),
              _: 1
            }), _cache[41] || (_cache[41] = _createTextVNode(" 启用导出单据 ", -1))]),
            _: 1
          })])], 512), [[_vShow, !exportEnabled.value]])]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "统计导出",
          name: "stats"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_cache[45] || (_cache[45] = _createElementVNode("div", null, [_createElementVNode("h3", {
            class: "text-sm font-semibold text-slate-700"
          }, "统计导出"), _createElementVNode("p", {
            class: "text-xs text-slate-500 mt-0.5"
          }, "按时间区间导出“清单 + 汇总”双 sheet 统计表")], -1)), _createElementVNode("div", _hoisted_24, [_cache[44] || (_cache[44] = _createElementVNode("span", {
            class: "text-sm text-slate-600"
          }, "启用统计导出", -1)), _createVNode(_component_el_switch, {
            modelValue: statsEnabled.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => statsEnabled.value = $event)
          }, null, 8, ["modelValue"])])]), _withDirectives(_createElementVNode("div", null, [_createVNode(StatsConfigEditor, {
            ref_key: "statsConfigEditorRef",
            ref: statsConfigEditorRef,
            fields: workflowFormData.form?.fields || [],
            "initial-config": workflowFormData.statsConfig
          }, null, 8, ["fields", "initial-config"])], 512), [[_vShow, statsEnabled.value]]), _withDirectives(_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_icon, {
            size: 40,
            class: "text-slate-300 mb-3"
          }, {
            default: _withCtx(() => [_createVNode(_unref(TrendCharts))]),
            _: 1
          }), _cache[47] || (_cache[47] = _createElementVNode("p", {
            class: "text-sm font-medium text-slate-700 mb-1"
          }, "统计导出未启用", -1)), _cache[48] || (_cache[48] = _createElementVNode("p", {
            class: "text-xs text-slate-500 mb-4"
          }, "开启后可配置清单列、汇总维度与统计指标", -1)), _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _cache[8] || (_cache[8] = $event => statsEnabled.value = true)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "mr-1"
            }, {
              default: _withCtx(() => [_createVNode(_unref(TrendCharts))]),
              _: 1
            }), _cache[46] || (_cache[46] = _createTextVNode(" 启用统计导出 ", -1))]),
            _: 1
          })])], 512), [[_vShow, !statsEnabled.value]])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_27, [_createVNode(_component_el_button, {
        onClick: prevStep
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "mr-1"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowLeft))]),
          _: 1
        }), _cache[49] || (_cache[49] = _createTextVNode(" 上一步 ", -1))]),
        _: 1
      }), _createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, [_cache[50] || (_cache[50] = _createTextVNode(" 表单字段: ", -1)), _createElementVNode("strong", _hoisted_30, _toDisplayString(formFieldCount.value), 1), _cache[51] || (_cache[51] = _createTextVNode(" 个 ", -1))]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: nextStep
      }, {
        default: _withCtx(() => [_cache[52] || (_cache[52] = _createTextVNode(" 下一步：流程设计 ", -1)), _createVNode(_component_el_icon, {
          class: "ml-1"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Right))]),
          _: 1
        })]),
        _: 1
      })])])], 512), [[_vShow, currentStep.value === 1]]), _withDirectives(_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createVNode(_component_el_button_group, {
        size: "small"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: undo,
          disabled: !canUndo.value,
          title: "撤销 (Ctrl+Z)"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(RefreshLeft))]),
            _: 1
          })]),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          onClick: redo,
          disabled: !canRedo.value,
          title: "重做 (Ctrl+Y)"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(RefreshRight))]),
            _: 1
          })]),
          _: 1
        }, 8, ["disabled"])]),
        _: 1
      }), _createVNode(_component_el_divider, {
        direction: "vertical",
        class: "!my-1 !h-5"
      }), _createElementVNode("div", _hoisted_34, [_createElementVNode("button", {
        onClick: zoomOut,
        class: "p-1.5 rounded hover:bg-white hover:shadow-sm transition-all",
        title: "缩小"
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Remove))]),
        _: 1
      })]), _createElementVNode("span", _hoisted_35, _toDisplayString(Math.round(zoom.value * 100)) + "%", 1), _createElementVNode("button", {
        onClick: zoomIn,
        class: "p-1.5 rounded hover:bg-white hover:shadow-sm transition-all",
        title: "放大"
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Plus))]),
        _: 1
      })])]), _createVNode(_component_el_button, {
        size: "small",
        onClick: fitView,
        title: "适应画布"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(FullScreen))]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_36, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
        size: "small",
        type: "primary",
        onClick: save,
        loading: saving.value
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Check))]),
          _: 1
        }), _cache[53] || (_cache[53] = _createElementVNode("span", {
          class: "ml-1"
        }, "保存流程", -1))]),
        _: 1
      }, 8, ["loading"])), [[_directive_permission, 'workflow:template:edit']])])]), _createElementVNode("div", _hoisted_37, [_createVNode(_component_el_button, {
        onClick: prevStep
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "mr-1"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowLeft))]),
          _: 1
        }), _cache[54] || (_cache[54] = _createTextVNode(" 上一步 ", -1))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_cache[56] || (_cache[56] = _createElementVNode("div", {
        class: "px-4 py-3 border-b border-slate-200 bg-slate-50/50"
      }, [_createElementVNode("h3", {
        class: "text-xs font-semibold text-slate-500 uppercase tracking-wider"
      }, "流程节点")], -1)), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(nodeTypes, nodeType => {
        return _createElementVNode("div", {
          key: nodeType.type,
          class: _normalizeClass(["group flex items-center gap-3 px-3 py-2.5 bg-slate-50 hover:bg-white border border-slate-200 hover:border-primary-300 rounded-lg cursor-grab active:cursor-grabbing transition-all duration-200 hover:shadow-md", [`node-type-${nodeType.type.toLowerCase()}`]]),
          draggable: "true",
          onDragstart: $event => onDragStart($event, nodeType)
        }, [_createElementVNode("div", {
          class: _normalizeClass(["w-9 h-9 rounded-lg flex items-center justify-center transition-transform group-hover:scale-105", nodeType.bgClass])
        }, [_createVNode(_component_el_icon, {
          size: 18,
          class: _normalizeClass(nodeType.iconClass)
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(nodeType.icon)))]),
          _: 2
        }, 1032, ["class"])], 2), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString(nodeType.label), 1), _createElementVNode("div", _hoisted_45, _toDisplayString(nodeType.description), 1)]), _createVNode(_component_el_icon, {
          class: "text-slate-300 opacity-0 group-hover:opacity-100 transition-opacity"
        }, {
          default: _withCtx(() => [_createVNode(_unref(MoreFilled))]),
          _: 1
        })], 42, _hoisted_42);
      }), 64))]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createVNode(_component_el_icon, {
        class: "text-primary-500 mt-0.5",
        size: 14
      }, {
        default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
        _: 1
      }), _cache[55] || (_cache[55] = _createElementVNode("div", {
        class: "text-xs text-primary-700"
      }, [_createElementVNode("p", {
        class: "font-medium mb-1"
      }, "使用提示"), _createElementVNode("p", {
        class: "text-primary-600"
      }, "从左侧拖拽节点到画布，连接节点创建流程")], -1))])])])]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", {
        ref_key: "canvasContainerRef",
        ref: canvasContainerRef,
        class: _normalizeClass(["flex-1 overflow-hidden relative", panMode.value ? 'cursor-grab active:cursor-grabbing' : 'cursor-default']),
        onDrop: onDrop,
        onDragover: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"])),
        onMousedown: onCanvasMouseDown,
        onContextmenu: _withModifiers(onCanvasContextMenu, ["prevent"]),
        onWheel: onCanvasWheel
      }, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createVNode(_component_el_tooltip, {
        content: "拖拽画布 (按住空格键)",
        placement: "right"
      }, {
        default: _withCtx(() => [_createElementVNode("button", {
          onClick: togglePanMode,
          class: _normalizeClass(["w-9 h-9 flex items-center justify-center rounded-lg hover:bg-slate-100 transition-all", {
            'bg-primary-100 text-primary-600': panMode.value
          }])
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Rank))]),
          _: 1
        })], 2)]),
        _: 1
      }), _createVNode(_component_el_divider, {
        class: "!my-1"
      }), _createVNode(_component_el_tooltip, {
        content: "自动布局",
        placement: "right"
      }, {
        default: _withCtx(() => [_createElementVNode("button", {
          class: "w-9 h-9 flex items-center justify-center rounded-lg hover:bg-slate-100 transition-all",
          onClick: autoLayout
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Grid))]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_tooltip, {
        content: "缩小视图",
        placement: "right"
      }, {
        default: _withCtx(() => [_createElementVNode("button", {
          class: "w-9 h-9 flex items-center justify-center rounded-lg hover:bg-slate-100 transition-all",
          onClick: zoomOut
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(ZoomOut))]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_tooltip, {
        content: "放大视图",
        placement: "right"
      }, {
        default: _withCtx(() => [_createElementVNode("button", {
          class: "w-9 h-9 flex items-center justify-center rounded-lg hover:bg-slate-100 transition-all",
          onClick: zoomIn
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(ZoomIn))]),
          _: 1
        })])]),
        _: 1
      })])]), _createElementVNode("div", {
        ref_key: "canvasRef",
        ref: canvasRef,
        class: "absolute inset-0 transition-transform duration-75",
        style: _normalizeStyle({
          transform: `translate(${panOffset.x}px, ${panOffset.y}px) scale(${zoom.value})`,
          transformOrigin: '0 0'
        }),
        onClick: onCanvasClick
      }, [(_openBlock(), _createElementBlock("svg", _hoisted_51, [...(_cache[57] || (_cache[57] = [_createStaticVNode("<defs data-v-4dcbb157><pattern id=\"grid\" width=\"20\" height=\"20\" patternUnits=\"userSpaceOnUse\" data-v-4dcbb157><circle cx=\"1\" cy=\"1\" r=\"1\" fill=\"#94a3b8\" opacity=\"0.4\" data-v-4dcbb157></circle></pattern><filter id=\"glow\" x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" data-v-4dcbb157><feGaussianBlur stdDeviation=\"2\" result=\"coloredBlur\" data-v-4dcbb157></feGaussianBlur><feMerge data-v-4dcbb157><feMergeNode in=\"coloredBlur\" data-v-4dcbb157></feMergeNode><feMergeNode in=\"SourceGraphic\" data-v-4dcbb157></feMergeNode></feMerge></filter></defs><rect width=\"100%\" height=\"100%\" fill=\"url(#grid)\" data-v-4dcbb157></rect>", 2)]))])), (_openBlock(), _createElementBlock("svg", _hoisted_52, [_cache[58] || (_cache[58] = _createElementVNode("defs", null, [_createElementVNode("marker", {
        id: "arrowhead",
        markerWidth: "10",
        markerHeight: "10",
        refX: "8",
        refY: "5",
        orient: "auto"
      }, [_createElementVNode("path", {
        d: "M 0 0 L 10 5 L 0 10 z",
        fill: "#64748b"
      })]), _createElementVNode("marker", {
        id: "arrowhead-selected",
        markerWidth: "10",
        markerHeight: "10",
        refX: "8",
        refY: "5",
        orient: "auto"
      }, [_createElementVNode("path", {
        d: "M 0 0 L 10 5 L 0 10 z",
        fill: "#3b82f6"
      })])], -1)), tempEdge.value ? (_openBlock(), _createElementBlock("path", {
        key: 0,
        d: getTempEdgePath(),
        stroke: "#3b82f6",
        "stroke-width": "2",
        fill: "none",
        "stroke-dasharray": "6,4",
        class: "transition-all duration-75"
      }, null, 8, _hoisted_53)) : _createCommentVNode("", true), _createElementVNode("g", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(edges.value, (edge, edgeIndex) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: getEdgeKey(edge, edgeIndex)
        }, [_createElementVNode("path", {
          d: getEdgePath(edge),
          stroke: isEdgeSelected(edge) ? '#3b82f6' : '#94a3b8',
          "stroke-width": isEdgeSelected(edge) ? 2.5 : 1.5,
          fill: "none",
          "marker-end": isEdgeSelected(edge) ? 'url(#arrowhead-selected)' : 'url(#arrowhead)',
          class: _normalizeClass(["flow-edge pointer-events-auto cursor-pointer transition-all duration-200", isEdgeSelected(edge) ? 'opacity-100' : 'opacity-70 hover:opacity-100 hover:stroke-slate-500']),
          onClick: _withModifiers($event => selectEdge(edge), ["stop"]),
          onContextmenu: _withModifiers($event => onEdgeContextMenu($event, edge), ["prevent", "stop"])
        }, null, 42, _hoisted_54), edge.label ? (_openBlock(), _createElementBlock("g", {
          key: 0,
          class: "pointer-events-auto cursor-pointer",
          onClick: _withModifiers($event => selectEdge(edge), ["stop"])
        }, [_createElementVNode("rect", {
          x: getEdgeLabelPosition(edge).x - 20,
          y: getEdgeLabelPosition(edge).y - 10,
          width: "40",
          height: "20",
          rx: "4",
          fill: "white",
          stroke: "#e2e8f0",
          class: _normalizeClass(["transition-all duration-200", {
            'stroke-primary-300 fill-primary-50': isEdgeSelected(edge)
          }])
        }, null, 10, _hoisted_56), _createElementVNode("text", {
          x: getEdgeLabelPosition(edge).x,
          y: getEdgeLabelPosition(edge).y + 4,
          "text-anchor": "middle",
          class: _normalizeClass(["text-[10px] font-medium pointer-events-none transition-colors duration-200", isEdgeSelected(edge) ? 'fill-primary-600' : 'fill-slate-500'])
        }, _toDisplayString(edge.label), 11, _hoisted_57)], 8, _hoisted_55)) : _createCommentVNode("", true)], 64);
      }), 128))])])), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nodes.value, node => {
        return _openBlock(), _createElementBlock("div", {
          key: node.id,
          "data-node-id": node.id,
          class: "absolute transition-all duration-150",
          style: _normalizeStyle({
            left: node.x + 'px',
            top: node.y + 'px',
            zIndex: selectedNode.value?.id === node.id ? 100 : 10
          }),
          onMousedown: _withModifiers($event => onNodeMouseDown($event, node), ["stop"]),
          onClick: _withModifiers($event => selectNode(node), ["stop"]),
          onContextmenu: _withModifiers($event => onNodeContextMenu($event, node), ["prevent", "stop"])
        }, [_createElementVNode("div", {
          class: _normalizeClass(["flow-node bg-white rounded-xl shadow-sm border-2 transition-all duration-200", [getNodeClass(node), {
            'ring-4 ring-primary-200/50 shadow-lg scale-[1.02]': selectedNode.value?.id === node.id,
            'hover:shadow-lg hover:scale-[1.01]': selectedNode.value?.id !== node.id
          }]]),
          style: _normalizeStyle({
            minWidth: getNodeWidth(node) + 'px'
          })
        }, [_createElementVNode("div", {
          class: _normalizeClass(["node-header px-4 py-2.5 rounded-t-lg flex items-center gap-2", getNodeHeaderClass(node)])
        }, [_createVNode(_component_el_icon, {
          size: 14
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(getNodeIcon(node.type))))]),
          _: 2
        }, 1024), _createElementVNode("span", _hoisted_59, _toDisplayString(node.label), 1), node.code ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 0,
          size: "small",
          class: "ml-auto !bg-white/20 !border-white/30 !text-inherit",
          hit: false
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(node.code), 1)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)], 2), hasNodeContent(node) ? (_openBlock(), _createElementBlock("div", _hoisted_60, [node.type === 'APPROVAL' ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createVNode(_component_el_icon, {
          size: 12,
          class: "text-slate-400"
        }, {
          default: _withCtx(() => [_createVNode(_unref(User))]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString(getApproverText(node)), 1)])) : _createCommentVNode("", true), node.type === 'CONDITION' && node.branches && node.branches.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_62, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(node.branches.slice(0, 3), (branch, idx) => {
          return _openBlock(), _createElementBlock("div", {
            key: idx,
            class: "flex items-center gap-1.5"
          }, [_createElementVNode("span", _hoisted_63, _toDisplayString(idx + 1), 1), _createElementVNode("span", _hoisted_64, _toDisplayString(branch?.label || `分支${idx + 1}`), 1)]);
        }), 128)), node.branches.length > 3 ? (_openBlock(), _createElementBlock("div", _hoisted_65, " +" + _toDisplayString(node.branches.length - 3) + " 更多 ", 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), node.type === 'CC' ? (_openBlock(), _createElementBlock("div", _hoisted_66, [_createVNode(_component_el_icon, {
          size: 12,
          class: "text-slate-400"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Message))]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString(getCcText(node)), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), node.type !== 'END' && node.type !== 'CONDITION' ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "node-handle node-handle-out",
          onMousedown: _withModifiers($event => onHandleMouseDown($event, node, 'out'), ["stop"])
        }, null, 40, _hoisted_67)) : _createCommentVNode("", true), node.type === 'CONDITION' && node.branches ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(node.branches, (branch, idx) => {
          return _openBlock(), _createElementBlock("div", {
            key: `branch-${idx}`,
            class: _normalizeClass(["node-handle node-handle-branch", `branch-handle-${idx}`]),
            style: _normalizeStyle(getBranchHandleStyle(node, idx)),
            title: `分支: ${branch.label || '分支' + (idx + 1)}`,
            onMousedown: _withModifiers($event => onHandleMouseDown($event, node, 'out', idx), ["stop"])
          }, [_createElementVNode("span", _hoisted_69, _toDisplayString(idx + 1), 1)], 46, _hoisted_68);
        }), 128)) : _createCommentVNode("", true), node.type !== 'START' ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "node-handle node-handle-in",
          onMousedown: _withModifiers($event => onHandleMouseDown($event, node, 'in'), ["stop"])
        }, null, 40, _hoisted_70)) : _createCommentVNode("", true)], 6)], 44, _hoisted_58);
      }), 128))], 4)], 34), _createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, [_createElementVNode("span", null, [_cache[59] || (_cache[59] = _createTextVNode("节点: ", -1)), _createElementVNode("strong", _hoisted_73, _toDisplayString(nodes.value.length), 1)]), _createElementVNode("span", null, [_cache[60] || (_cache[60] = _createTextVNode("连线: ", -1)), _createElementVNode("strong", _hoisted_74, _toDisplayString(edges.value.length), 1)])]), _createElementVNode("div", _hoisted_75, [selectedNode.value ? (_openBlock(), _createElementBlock("span", _hoisted_76, "已选择: " + _toDisplayString(selectedNode.value.label), 1)) : selectedEdge.value ? (_openBlock(), _createElementBlock("span", _hoisted_77, "已选择连线")) : (_openBlock(), _createElementBlock("span", _hoisted_78, "点击画布空白处取消选择"))])])]), selectedNode.value || selectedEdge.value ? (_openBlock(), _createElementBlock("div", _hoisted_79, [_createElementVNode("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_createVNode(_component_el_icon, {
        size: 16,
        class: "text-slate-400"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Setting))]),
        _: 1
      }), _createElementVNode("h3", _hoisted_82, _toDisplayString(selectedNode.value ? '节点属性' : '连线属性'), 1)]), _createElementVNode("button", {
        onClick: closePropertyPanel,
        class: "p-1 rounded hover:bg-slate-200 transition-colors"
      }, [_createVNode(_component_el_icon, {
        size: 14
      }, {
        default: _withCtx(() => [_createVNode(_unref(Close))]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_83, [selectedNode.value ? (_openBlock(), _createBlock(_component_el_form, {
        key: 0,
        "label-position": "top",
        class: "p-4 space-y-4"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_84, [_createElementVNode("div", {
          class: _normalizeClass(["w-10 h-10 rounded-lg flex items-center justify-center", getNodeBgClass(selectedNode.value.type)])
        }, [_createVNode(_component_el_icon, {
          size: 20,
          class: _normalizeClass(getNodeIconClass(selectedNode.value.type))
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(getNodeIcon(selectedNode.value.type))))]),
          _: 1
        }, 8, ["class"])], 2), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_85, _toDisplayString(selectedNode.value.label), 1), _createElementVNode("div", _hoisted_86, _toDisplayString(getNodeTypeLabel(selectedNode.value.type)), 1)])]), _createVNode(_component_el_form_item, {
          label: "节点名称",
          class: "!mb-3"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: selectedNode.value.label,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => selectedNode.value.label = $event),
            placeholder: "请输入节点名称",
            size: "small"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), selectedNode.value.type === 'APPROVAL' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_divider, {
          "content-position": "left",
          class: "!my-4"
        }, {
          default: _withCtx(() => [...(_cache[61] || (_cache[61] = [_createTextVNode("审批配置", -1)]))]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "审批人方式",
          class: "!mb-3"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: selectedNode.value.config.approverMode,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => selectedNode.value.config.approverMode = $event),
            class: "w-full",
            size: "small",
            onChange: onApproverModeChange
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "发起人自选",
              value: "STARTER_SELECTED"
            }), _createVNode(_component_el_option, {
              label: "指定用户",
              value: "USER"
            }), _createVNode(_component_el_option, {
              label: "指定角色",
              value: "ROLE"
            }), _createVNode(_component_el_option, {
              label: "部门负责人",
              value: "DEPT_LEADER"
            }), _createVNode(_component_el_option, {
              label: "发起人主管（暂未支持）",
              value: "INITIATOR_MANAGER",
              disabled: ""
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), ['USER', 'ROLE'].includes(selectedNode.value.config.approverMode) ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "审批人值",
          class: "!mb-3"
        }, {
          default: _withCtx(() => [selectedNode.value.config.approverMode === 'USER' ? (_openBlock(), _createBlock(UserSelector, {
            key: 0,
            modelValue: approverUserIds.value,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => approverUserIds.value = $event),
            multiple: "",
            placeholder: "请选择审批人"
          }, null, 8, ["modelValue"])) : selectedNode.value.config.approverMode === 'ROLE' ? (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            modelValue: approverValueArray.value,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => approverValueArray.value = $event),
            placeholder: "请选择角色",
            filterable: "",
            clearable: "",
            multiple: "",
            "collapse-tags": "",
            "collapse-tags-tooltip": "",
            "value-key": "id",
            class: "w-full",
            size: "small",
            loading: roleLoading.value
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, role => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: role.id,
                label: role.label,
                value: role
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "loading"])) : _createCommentVNode("", true)]),
          _: 1
        })) : _createCommentVNode("", true), shouldRenderStarterSelectionPanel(selectedNode.value) ? (_openBlock(), _createElementBlock("div", _hoisted_87, [selectedNode.value.config.approverMode !== 'STARTER_SELECTED' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "发起人补充选择",
          class: "!mb-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: selectedNode.value.config.selectionEnabled,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => selectedNode.value.config.selectionEnabled = $event),
            onChange: onSupplementSelectionToggle
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), shouldShowStarterSelectionConfig(selectedNode.value) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_el_form_item, {
          label: "是否必选",
          class: "!mb-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: selectedNode.value.config.selectionRequired,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => selectedNode.value.config.selectionRequired = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_88, [_createVNode(_component_el_form_item, {
          label: "最少人数",
          class: "!mb-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: selectedNode.value.config.minSelect,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => selectedNode.value.config.minSelect = $event),
            min: 0,
            max: 99,
            size: "small",
            class: "w-full"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "最多人数",
          class: "!mb-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: selectedNode.value.config.maxSelect,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => selectedNode.value.config.maxSelect = $event),
            min: 1,
            max: 99,
            size: "small",
            class: "w-full"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]), _createVNode(_component_el_form_item, {
          label: "允许选自己",
          class: "!mb-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: selectedNode.value.config.allowApplicant,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => selectedNode.value.config.allowApplicant = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), shouldShowAutomaticParticipantInfo(selectedNode.value) ? (_openBlock(), _createElementBlock("div", _hoisted_89, [_createVNode(_component_el_icon, {
          class: "mr-1"
        }, {
          default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
          _: 1
        }), _createTextVNode(" " + _toDisplayString(selectedNode.value.config.approverMode === 'DEPT_LEADER' ? '自动获取发起人所在部门的负责人' : '自动获取发起人的直接主管'), 1)])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "审批模式",
          class: "!mb-3"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: selectedNode.value.config.approvalMode,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => selectedNode.value.config.approvalMode = $event),
            class: "w-full",
            size: "small"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "或签(任一同意)",
              value: "ANY"
            }), _createVNode(_component_el_option, {
              label: "会签(全部同意)",
              value: "ALL"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_90, [_createVNode(_component_el_form_item, {
          label: "超时时间(小时)",
          class: "!mb-3"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: selectedNode.value.config.timeoutHours,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => selectedNode.value.config.timeoutHours = $event),
            min: 1,
            max: 720,
            class: "w-full",
            size: "small"
          }, null, 8, ["modelValue"])]),
          _: 1
        })])], 64)) : _createCommentVNode("", true), selectedNode.value.type === 'CONDITION' && selectedNode.value.branches ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_el_divider, {
          "content-position": "left",
          class: "!my-4"
        }, {
          default: _withCtx(() => [...(_cache[62] || (_cache[62] = [_createTextVNode("条件配置", -1)]))]),
          _: 1
        }), availableFields.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, [_createVNode(_component_el_icon, {
          class: "text-amber-500 mt-0.5"
        }, {
          default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
          _: 1
        }), _cache[63] || (_cache[63] = _createElementVNode("div", {
          class: "flex-1 text-xs"
        }, [_createElementVNode("p", {
          class: "font-medium text-amber-800 mb-0.5"
        }, "暂无可用字段"), _createElementVNode("p", {
          class: "text-amber-600"
        }, "请先点击工具栏的\"表单设计\"按钮创建表单字段")], -1))])])) : (_openBlock(), _createElementBlock("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_createVNode(_component_el_icon, {
          class: "text-emerald-500"
        }, {
          default: _withCtx(() => [_createVNode(_unref(CircleCheck))]),
          _: 1
        }), _createElementVNode("span", null, [_cache[64] || (_cache[64] = _createTextVNode("已加载 ", -1)), _createElementVNode("strong", null, _toDisplayString(availableFields.value.length), 1), _cache[65] || (_cache[65] = _createTextVNode(" 个表单字段", -1))])])])), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedNode.value.branches, (branch, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "mb-3 p-3 bg-slate-50 rounded-lg border border-slate-200"
          }, [_createElementVNode("div", _hoisted_95, [_createElementVNode("span", _hoisted_96, [_createElementVNode("span", _hoisted_97, _toDisplayString(index + 1), 1), _createTextVNode(" 分支 " + _toDisplayString(index + 1), 1)]), selectedNode.value.branches.length > 1 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "danger",
            link: "",
            size: "small",
            onClick: $event => removeBranch(index)
          }, {
            default: _withCtx(() => [...(_cache[66] || (_cache[66] = [_createTextVNode(" 删除 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createVNode(_component_el_form_item, {
            label: "分支名称",
            "label-width": "70px",
            class: "!mb-2"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: branch.label,
              "onUpdate:modelValue": $event => branch.label = $event,
              placeholder: "如：金额>=1000",
              size: "small"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 2
          }, 1024), branch.condition ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_form_item, {
            label: "条件字段",
            "label-width": "70px",
            class: "!mb-2"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: branch.condition.field,
              "onUpdate:modelValue": $event => branch.condition.field = $event,
              filterable: "",
              "allow-create": "",
              placeholder: "选择或输入字段",
              size: "small",
              class: "w-full"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableFields.value || [], field => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: field.key,
                  label: field.label,
                  value: field.key
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 2
          }, 1024), _createElementVNode("div", _hoisted_98, [_createVNode(_component_el_form_item, {
            label: "运算符",
            "label-width": "70px",
            class: "!mb-2"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: branch.condition.operator,
              "onUpdate:modelValue": $event => branch.condition.operator = $event,
              size: "small",
              class: "w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "等于",
                value: "EQ"
              }), _createVNode(_component_el_option, {
                label: "不等于",
                value: "NEQ"
              }), _createVNode(_component_el_option, {
                label: "大于",
                value: "GT"
              }), _createVNode(_component_el_option, {
                label: "大于等于",
                value: "GTE"
              }), _createVNode(_component_el_option, {
                label: "小于",
                value: "LT"
              }), _createVNode(_component_el_option, {
                label: "小于等于",
                value: "LTE"
              }), _createVNode(_component_el_option, {
                label: "包含",
                value: "CONTAINS"
              }), _createVNode(_component_el_option, {
                label: "不包含",
                value: "NOT_CONTAINS"
              })]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 2
          }, 1024), _createVNode(_component_el_form_item, {
            label: "条件值",
            "label-width": "70px",
            class: "!mb-2"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: branch.condition.value,
              "onUpdate:modelValue": $event => branch.condition.value = $event,
              placeholder: "条件值",
              size: "small"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 2
          }, 1024)])], 64)) : _createCommentVNode("", true)]);
        }), 128)), _createVNode(_component_el_button, {
          type: "primary",
          link: "",
          onClick: addBranch,
          class: "w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          }), _cache[67] || (_cache[67] = _createTextVNode(" 添加分支 ", -1))]),
          _: 1
        })], 64)) : _createCommentVNode("", true), selectedNode.value.type === 'CC' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createVNode(_component_el_divider, {
          "content-position": "left",
          class: "!my-4"
        }, {
          default: _withCtx(() => [...(_cache[68] || (_cache[68] = [_createTextVNode("抄送配置", -1)]))]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "抄送方式",
          class: "!mb-3"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: selectedNode.value.config.approverMode,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => selectedNode.value.config.approverMode = $event),
            class: "w-full",
            size: "small",
            onChange: onApproverModeChange
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "发起人自选",
              value: "STARTER_SELECTED"
            }), _createVNode(_component_el_option, {
              label: "指定用户",
              value: "USER"
            }), _createVNode(_component_el_option, {
              label: "指定角色",
              value: "ROLE"
            }), _createVNode(_component_el_option, {
              label: "部门负责人",
              value: "DEPT_LEADER"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), selectedNode.value.config.approverMode !== 'STARTER_SELECTED' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "抄送值",
          class: "!mb-3"
        }, {
          default: _withCtx(() => [selectedNode.value.config.approverMode === 'USER' ? (_openBlock(), _createBlock(UserSelector, {
            key: 0,
            modelValue: approverUserIds.value,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => approverUserIds.value = $event),
            multiple: "",
            placeholder: "请选择抄送人"
          }, null, 8, ["modelValue"])) : selectedNode.value.config.approverMode === 'ROLE' ? (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            modelValue: approverValueArray.value,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => approverValueArray.value = $event),
            placeholder: "请选择角色",
            filterable: "",
            clearable: "",
            multiple: "",
            "collapse-tags": "",
            "collapse-tags-tooltip": "",
            "value-key": "id",
            class: "w-full",
            size: "small",
            loading: roleLoading.value
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, role => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: role.id,
                label: role.label,
                value: role
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "loading"])) : selectedNode.value.config.approverMode === 'DEPT_LEADER' ? (_openBlock(), _createBlock(DeptSelector, {
            key: 2,
            modelValue: deptLeaderSelection.value,
            "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => deptLeaderSelection.value = $event),
            multiple: false,
            placeholder: "请选择部门"
          }, null, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_el_input, {
            key: 3,
            modelValue: selectedNode.value.config.approverValue,
            "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => selectedNode.value.config.approverValue = $event),
            placeholder: "动态指定",
            size: "small"
          }, null, 8, ["modelValue"]))]),
          _: 1
        })) : _createCommentVNode("", true), shouldRenderStarterSelectionPanel(selectedNode.value) ? (_openBlock(), _createElementBlock("div", _hoisted_99, [selectedNode.value.config.approverMode !== 'STARTER_SELECTED' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "发起人补充选择",
          class: "!mb-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: selectedNode.value.config.selectionEnabled,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => selectedNode.value.config.selectionEnabled = $event),
            onChange: onSupplementSelectionToggle
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), shouldShowStarterSelectionConfig(selectedNode.value) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_el_form_item, {
          label: "是否必选",
          class: "!mb-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: selectedNode.value.config.selectionRequired,
            "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => selectedNode.value.config.selectionRequired = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_100, [_createVNode(_component_el_form_item, {
          label: "最少人数",
          class: "!mb-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: selectedNode.value.config.minSelect,
            "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => selectedNode.value.config.minSelect = $event),
            min: 0,
            max: 99,
            size: "small",
            class: "w-full"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "最多人数",
          class: "!mb-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: selectedNode.value.config.maxSelect,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => selectedNode.value.config.maxSelect = $event),
            min: 1,
            max: 99,
            size: "small",
            class: "w-full"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]), _createVNode(_component_el_form_item, {
          label: "允许选自己",
          class: "!mb-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: selectedNode.value.config.allowApplicant,
            "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => selectedNode.value.config.allowApplicant = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _createVNode(_component_el_divider, {
          class: "!my-4"
        }), _createVNode(_component_el_button, {
          type: "danger",
          size: "small",
          class: "w-full",
          onClick: deleteNode
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Delete))]),
            _: 1
          }), _cache[69] || (_cache[69] = _createTextVNode(" 删除节点 ", -1))]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), selectedEdge.value ? (_openBlock(), _createBlock(_component_el_form, {
        key: 1,
        "label-position": "top",
        class: "p-4 space-y-4"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, [_cache[70] || (_cache[70] = _createElementVNode("span", {
          class: "text-slate-500"
        }, "连线ID", -1)), _createElementVNode("span", _hoisted_103, _toDisplayString(selectedEdge.value.id), 1)])]), _createVNode(_component_el_form_item, {
          label: "连线标签",
          class: "!mb-3"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: selectedEdge.value.label,
            "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => selectedEdge.value.label = $event),
            placeholder: "如：是/否、通过/拒绝",
            size: "small"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_104, [_createVNode(_component_el_form_item, {
          label: "源节点",
          class: "!mb-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            "model-value": getNodeLabel(selectedEdge.value.source),
            disabled: "",
            size: "small"
          }, null, 8, ["model-value"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "目标节点",
          class: "!mb-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            "model-value": getNodeLabel(selectedEdge.value.target),
            disabled: "",
            size: "small"
          }, null, 8, ["model-value"])]),
          _: 1
        })]), _createVNode(_component_el_divider, {
          class: "!my-4"
        }), _createVNode(_component_el_button, {
          type: "danger",
          size: "small",
          class: "w-full",
          onClick: deleteEdge
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Delete))]),
            _: 1
          }), _cache[71] || (_cache[71] = _createTextVNode(" 删除连线 ", -1))]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "context-menu"
      }, {
        default: _withCtx(() => [contextMenu.visible ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed bg-white rounded-xl shadow-xl border border-slate-200 py-1.5 z-50 min-w-[140px] overflow-hidden",
          style: _normalizeStyle({
            left: contextMenu.x + 'px',
            top: contextMenu.y + 'px'
          }),
          onClick: closeContextMenu
        }, [contextMenu.type === 'node' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("button", {
          class: "w-full px-4 py-2 text-left text-sm hover:bg-slate-50 flex items-center gap-2.5 transition-colors",
          onClick: copyNode
        }, [_createVNode(_component_el_icon, {
          class: "text-slate-400"
        }, {
          default: _withCtx(() => [_createVNode(_unref(DocumentCopy))]),
          _: 1
        }), _cache[72] || (_cache[72] = _createElementVNode("span", {
          class: "text-slate-700"
        }, "复制节点", -1))]), _cache[74] || (_cache[74] = _createElementVNode("div", {
          class: "h-px bg-slate-100 my-1"
        }, null, -1)), _createElementVNode("button", {
          class: "w-full px-4 py-2 text-left text-sm hover:bg-red-50 flex items-center gap-2.5 transition-colors",
          onClick: deleteNode
        }, [_createVNode(_component_el_icon, {
          class: "text-red-500"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Delete))]),
          _: 1
        }), _cache[73] || (_cache[73] = _createElementVNode("span", {
          class: "text-red-600"
        }, "删除节点", -1))])], 64)) : _createCommentVNode("", true), contextMenu.type === 'edge' ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "w-full px-4 py-2 text-left text-sm hover:bg-red-50 flex items-center gap-2.5 transition-colors",
          onClick: deleteEdge
        }, [_createVNode(_component_el_icon, {
          class: "text-red-500"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Delete))]),
          _: 1
        }), _cache[75] || (_cache[75] = _createElementVNode("span", {
          class: "text-red-600"
        }, "删除连线", -1))])) : _createCommentVNode("", true), contextMenu.type === 'canvas' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [copiedNode.value ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "w-full px-4 py-2 text-left text-sm hover:bg-slate-50 flex items-center gap-2.5 transition-colors",
          onClick: pasteNode
        }, [_createVNode(_component_el_icon, {
          class: "text-slate-400"
        }, {
          default: _withCtx(() => [_createVNode(_unref(DocumentAdd))]),
          _: 1
        }), _cache[76] || (_cache[76] = _createElementVNode("span", {
          class: "text-slate-700"
        }, "粘贴节点", -1))])) : _createCommentVNode("", true), _createElementVNode("button", {
          class: "w-full px-4 py-2 text-left text-sm hover:bg-slate-50 flex items-center gap-2.5 transition-colors",
          onClick: autoLayout
        }, [_createVNode(_component_el_icon, {
          class: "text-slate-400"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Connection))]),
          _: 1
        }), _cache[77] || (_cache[77] = _createElementVNode("span", {
          class: "text-slate-700"
        }, "自动布局", -1))])], 64)) : _createCommentVNode("", true)], 4)) : _createCommentVNode("", true)]),
        _: 1
      })])), _createVNode(_component_el_dialog, {
        modelValue: formDesignerVisible.value,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => formDesignerVisible.value = $event),
        title: "表单设计器",
        width: "90%",
        "close-on-click-modal": false,
        top: "5vh",
        "destroy-on-close": true,
        modal: true,
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[33] || (_cache[33] = $event => formDesignerVisible.value = false)
        }, {
          default: _withCtx(() => [...(_cache[78] || (_cache[78] = [_createTextVNode("关闭", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: applyFormFields
        }, {
          default: _withCtx(() => [...(_cache[79] || (_cache[79] = [_createTextVNode("应用表单字段", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [(_openBlock(), _createBlock(FormDesigner, {
          key: formDesignerKey.value,
          ref_key: "formDesignerRef",
          ref: formDesignerRef,
          "initial-form": workflowFormData.form,
          onSave: onFormSave
        }, null, 8, ["initial-form"]))]),
        _: 1
      }, 8, ["modelValue"])], 512), [[_vShow, currentStep.value === 2]])])]);
    };
  }
};